import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainLayout from "../layout/MainLayout";
import { hasPermission } from "../utils/permissions";
import { API_BASE } from "../config/orbisConfig";


function GridRowsProStyle() {
    return (
        <style>{`
            .grid-rows-pro table {
                border-collapse: separate !important;
                border-spacing: 0 !important;
                background: #061a2f !important;
            }

            .grid-rows-pro table thead th {
                position: sticky;
                top: 0;
                z-index: 10;
                background: #061a2f !important;
                color: #8fb9da !important;
                border-bottom: 1px solid #24587c !important;
                text-transform: uppercase;
                letter-spacing: .13em;
            }

            .grid-rows-pro table tbody tr {
                transition: background 0.18s ease, box-shadow 0.18s ease;
                background: #08233d !important;
            }

            .grid-rows-pro table tbody tr:nth-child(even) {
                background: #092a49 !important;
            }

            .grid-rows-pro table tbody tr:hover {
                background: rgba(56,189,248,.075) !important;
                box-shadow: inset 3px 0 0 #d4af37 !important;
            }

            .grid-rows-pro table tbody tr:hover td,
            .grid-rows-pro table tbody td {
                font-size: 14px;
                color: #f5fbff !important;
                vertical-align: top;
                border-top: 1px solid #24587c !important;
                background: transparent !important;
            }

            .grid-rows-pro table tbody td .grid-row-main {
                font-weight: 700;
                color: #ffffff !important;
            }

            .grid-rows-pro table tbody td .grid-row-sub {
                color: #9fc4df !important;
                font-size: 12px;
            }

            .grid-rows-pro ul.grid-hover-list > li {
                transition: background 0.18s ease, box-shadow 0.18s ease;
                background: #08233d !important;
                border-color: #24587c !important;
                color: #f5fbff !important;
            }

            .grid-rows-pro ul.grid-hover-list > li:nth-child(even) {
                background: #092a49 !important;
            }

            .grid-rows-pro ul.grid-hover-list > li:hover {
                background: rgba(56,189,248,.075) !important;
                box-shadow: inset 3px 0 0 #d4af37 !important;
            }

            .affiliates-pro {
                background:#041426 !important;
                color:#f5fbff !important;
            }

            .affiliates-pro .bg-[#04192b],
            .affiliates-pro .bg-gray-50,
            .affiliates-pro .bg-slate-50 {
                background:#04192b !important;
                color:#f5fbff !important;
            }

            .affiliates-pro .border-[#0b4d78],
            .affiliates-pro .border-gray-200,
            .affiliates-pro .border-slate-200 {
                border-color:#0b4d78 !important;
            }

            .affiliates-pro input,
            .affiliates-pro select,
            .affiliates-pro textarea {
                background:#0b2740 !important;
                color:#fff !important;
                border:1px solid #0b5f91 !important;
                border-radius:12px !important;
            }

            .affiliates-pro select option {
                background:#061a2f !important;
                color:#fff !important;
            }

            .affiliates-pro input::placeholder,
            .affiliates-pro textarea::placeholder {
                color:#7ea8c7 !important;
            }

            .affiliates-pro input:focus,
            .affiliates-pro select:focus,
            .affiliates-pro textarea:focus {
                border-color:#d4af37 !important;
                box-shadow:0 0 0 2px rgba(212,175,55,.18) !important;
                outline:none !important;
            }

            .affiliates-pro button {
                border-radius:999px !important;
                font-weight:700 !important;
            }

            .affiliates-pro .bg-[#d4af37] {
                background:#d4af37 !important;
                color:#081a2b !important;
                border-color:#d4af37 !important;
            }

            .affiliates-pro .text-white,
            .affiliates-pro .text-gray-900,
            .affiliates-pro .text-slate-900 {
                color:#fff !important;
            }

            .affiliates-pro .text-[#9fc4df],
            .affiliates-pro .text-[#d7e8f6],
            .affiliates-pro .text-[#d9e8f5],
            .affiliates-pro .text-slate-500,
            .affiliates-pro .text-slate-600,
            .affiliates-pro .text-slate-700 {
                color:#9fc4df !important;
            }

            .affiliates-pro .hover\:bg-cani-bg:hover,
            .affiliates-pro .hover\:bg-[#04192b]:hover,
            .affiliates-pro .hover\:bg-gray-50:hover {
                background:#10324f !important;
            }

            .affiliates-pro [style*="background: #fff"],
            .affiliates-pro [style*="background:#fff"],
            .affiliates-pro [style*="background: #ffffff"],
            .affiliates-pro [style*="background:#ffffff"],
            .affiliates-pro [style*="background: white"],
            .affiliates-pro [style*="background:white"] {
                background:#08233d !important;
                color:#f5fbff !important;
            }
        `}</style>
    );
}

//const API_BASE = `${window.location.origin}${API_BASE}`;

function authHeaders(extra = {}) {
    const token = localStorage.getItem("cani_auth") || "";
    return {
        ...extra,
        Authorization: `Bearer ${token}`,
        "X-CANI-AUTH": token,
    };
}

function buildQuery(params) {
    const sp = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
        if (v === undefined || v === null) return;
        const s = String(v).trim();
        if (s === "") return;
        sp.set(k, s);
    });
    const qs = sp.toString();
    return qs ? `?${qs}` : "";
}

const STATUS_OPTIONS = [
    "Prospecto",
    "Contactado por email",
    "Contactado por teléfono",
    "Contactado por videollamada",
    "Invitación a reunión",
    "Interés institucional",
    "Aceptó afiliarse",
    "Documentación solicitada",
    "Registro iniciado",
    "Afiliado (sin pago)",
    "Afiliado (pago pendiente)",
    "Afiliado activo (con estrategia)",
    "Afiliado activo (sin estrategia)",
    "Baja",
];

const ACTIVE_STATUSES = new Set([
    "Afiliado activo (con estrategia)",
    "Afiliado activo (sin estrategia)",
]);

const STATUS_GROUP_STYLES = {
    Prospecto: { bg: "#f8fafc", border: "#cbd5e1", accent: "#475569" },
    "Contactado por email": { bg: "#f8fafc", border: "#cbd5e1", accent: "#64748b" },
    "Contactado por teléfono": { bg: "#f8fafc", border: "#cbd5e1", accent: "#64748b" },
    "Contactado por videollamada": { bg: "#f8fafc", border: "#cbd5e1", accent: "#64748b" },
    "Invitación a reunión": { bg: "#eff6ff", border: "#bfdbfe", accent: "#2563eb" },
    "Interés institucional": { bg: "#eef2ff", border: "#c7d2fe", accent: "#4f46e5" },
    "Aceptó afiliarse": { bg: "#eef2ff", border: "#c7d2fe", accent: "#4f46e5" },
    "Documentación solicitada": { bg: "#f5f3ff", border: "#ddd6fe", accent: "#7c3aed" },
    "Registro iniciado": { bg: "#fff7ed", border: "#fed7aa", accent: "#ea580c" },
    "Afiliado (sin pago)": { bg: "#fefce8", border: "#fde68a", accent: "#ca8a04" },
    "Afiliado (pago pendiente)": { bg: "#fff7ed", border: "#fdba74", accent: "#f97316" },
    "Afiliado activo (con estrategia)": { bg: "#ecfdf5", border: "#a7f3d0", accent: "#059669" },
    "Afiliado activo (sin estrategia)": { bg: "#ecfeff", border: "#a5f3fc", accent: "#0891b2" },
    Baja: { bg: "#fef2f2", border: "#fecaca", accent: "#dc2626" },
};


const PIPELINE_ACTION_LABELS = {
    sin_contacto: "Vincular contacto principal",
    sin_actividad: "Registrar seguimiento",
    sin_pm: "Asignar responsable PM",
    docs_pendientes: "Solicitar / completar documentos",
    estancada: "Intervención directiva",
    cerrar_pago: "Escalar cierre / pago",
    mantener: "Mantener seguimiento",
};

function compactDate(value) {
    if (!value) return "Sin fecha";
    const s = String(value).slice(0, 10);
    const parts = s.split("-");
    if (parts.length === 3 && parts[0].length === 4) {
        return `${parts[2]}/${parts[1]}`;
    }
    return s || "Sin fecha";
}

function daysLabel(value) {
    const n = Number(value || 0);
    if (n <= 0) return "Hoy";
    if (n === 1) return "1 día";
    return `${n} días`;
}

function pipelineActionLabel(value) {
    return PIPELINE_ACTION_LABELS[value] || value || "Revisar seguimiento";
}

function pipelineStageAccent(stage, index = 0) {
    const palette = ["#38bdf8", "#2dd4bf", "#a78bfa", "#f59e0b", "#fb923c", "#22c55e", "#d4af37", "#ef4444"];
    return stage?.color_hex || stage?.accent || palette[index % palette.length];
}


function getStatusStyle(status, active) {
    const base = STATUS_GROUP_STYLES[status] || {
        bg: "#08233d",
        border: "#0b4d78",
        accent: "#8fb9da",
    };

    return {
        background: active ? "#0b2740" : "#08233d",
        borderColor: active ? base.accent : "#0b4d78",
        boxShadow: active ? `inset 3px 0 0 ${base.accent}, 0 12px 30px rgba(0,0,0,.20)` : "0 12px 30px rgba(0,0,0,.14)",
        accent: base.accent,
    };
}

function getIndustryDisplay(row) {
    const code = row?.industry_code || row?.industry_short_code || "";
    const name = row?.industry_name || row?.industry || "";
    if (code && name) return `${code}: ${name}`;
    return name || code || row?.sector_text || "—";
}

function getSectionOptionLabel(sec) {
    const title = sec?.title || sec?.name || `Sección ${sec?.id || ""}`;
    const description = sec?.description || sec?.notes || "";
    return description ? `${title}: ${description}` : title;
}

function getContactDisplayName(contact) {
    return (
        contact?.full_name ||
        [contact?.first_name, contact?.last_name].filter(Boolean).join(" ").trim() ||
        "Sin nombre"
    );
}

function Modal({ open, title, subtitle, onClose, children }) {
    if (!open) return null;

    return (
        <>
            <div
                onClick={onClose}
                style={{
                    position: "fixed",
                    inset: 0,
                    background: "rgba(2,6,23,0.45)",
                    zIndex: 2000,
                }}
            />
            <div
                style={{
                    position: "fixed",
                    inset: 0,
                    zIndex: 2100,
                    display: "grid",
                    placeItems: "center",
                    padding: 16,
                }}
            >
                <div
                    className="bg-[#04192b] border border-[#0b4d78] rounded-xl shadow-2xl"
                    style={{ width: "min(1180px, 96vw)", maxHeight: "90vh", overflow: "auto" }}
                >
                    <div className="px-4 py-3 border-b border-[#0b4d78] flex items-center justify-between">
                        <div>
                            <h3 className="text-xs font-semibold text-white" style={{ margin: 0 }}>
                                {title}
                            </h3>
                            {subtitle ? (
                                <p className="text-[10px] text-[#9fc4df]" style={{ margin: 0 }}>
                                    {subtitle}
                                </p>
                            ) : null}
                        </div>
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-2 py-1 rounded-lg bg-[#04192b] border border-[#0b4d78] text-[10px] text-[#d9e8f5] hover:bg-[#10324f]"
                        >
                            Cerrar
                        </button>
                    </div>
                    <div className="p-4">{children}</div>
                </div>
            </div>
        </>
    );
}

export default function AffiliateCompaniesPage() {
    const navigate = useNavigate();
    const role = String(localStorage.getItem("role") || "pm").toLowerCase();
    const canAdmin = role === "admin" || role === "administrador";

    const canCreate = hasPermission("affiliate_companies.create");
    const canEdit = hasPermission("affiliate_companies.edit");
    const canDelete = hasPermission("affiliate_companies.delete");

    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [toast, setToast] = useState(null);
    const [kpis, setKpis] = useState(null);
    const [kpisLoading, setKpisLoading] = useState(false);

    const [pmUsers, setPmUsers] = useState([]);
    const [industries, setIndustries] = useState([]);
    const [sections, setSections] = useState([]);
    const [sectionsLoading, setSectionsLoading] = useState(false);

    const [filters, setFilters] = useState({
        region: "",
        name: "",
        city: "",
        phone: "",
        email: "",
        rubro: "",
        status: "",
        industry_id: "",
        pm_user_id: "",
    });

    const [regionsOptions, setRegionsOptions] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: "name", direction: "asc" });
    const [attentionFilter, setAttentionFilter] = useState("");
    const [pipelineData, setPipelineData] = useState(null);
    const [pipelineLoading, setPipelineLoading] = useState(false);
    const [pipelineView, setPipelineView] = useState("kanban");
    const [affiliationInsightView, setAffiliationInsightView] = useState("pipeline");

    const [modalOpen, setModalOpen] = useState(false);
    const [draft, setDraft] = useState(null);
    const [detailMode, setDetailMode] = useState("detail");

    const [selectedCompany, setSelectedCompany] = useState(null);

    const [activities, setActivities] = useState([]);
    const [activitiesLoading, setActivitiesLoading] = useState(false);
    const [savingActivity, setSavingActivity] = useState(false);
    const [activityEditId, setActivityEditId] = useState(null);
    const [activityForm, setActivityForm] = useState({
        type: "email_enviado",
        channel: "email",
        subject: "",
        description: "",
    });

    const [structureItems, setStructureItems] = useState([]);
    const [structureLoading, setStructureLoading] = useState(false);
    const [structureDraft, setStructureDraft] = useState({
        role_title: "",
        person_name: "",
        email: "",
        phone: "",
        notes: "",
    });
    const [structureEdit, setStructureEdit] = useState(null);

    const [masterContacts, setMasterContacts] = useState([]);
    const [masterContactsLoading, setMasterContactsLoading] = useState(false);
    const [companyContacts, setCompanyContacts] = useState([]);
    const [companyContactsLoading, setCompanyContactsLoading] = useState(false);
    const [linkingContact, setLinkingContact] = useState(false);
    const [contactPickerId, setContactPickerId] = useState("");
    const [contactSearch, setContactSearch] = useState("");

    const [importOpen, setImportOpen] = useState(false);
    const [importFile, setImportFile] = useState(null);
    const [importing, setImporting] = useState(false);

    const topScrollRef = useRef(null);
    const bottomScrollRef = useRef(null);
    const syncingScrollRef = useRef(false);

    const widths = {
        company: 350,
        region: 105,
        city: 130,
        status: 145,
        industry: 190,
        pm: 80,
        email: 210,
        phone: 115,
        actions: 215,
    };

    const tableMinWidth = Object.values(widths).reduce((a, b) => a + b, 0);

    async function safeJson(url, options = {}) {
        const res = await fetch(url, options);
        const txt = await res.text();

        if (!txt) {
            throw new Error(`Respuesta vacía (HTTP ${res.status})`);
        }

        let data;
        try {
            data = JSON.parse(txt);
        } catch {
            throw new Error(`Respuesta no JSON (HTTP ${res.status}): ${txt.slice(0, 200)}`);
        }

        if (!res.ok) {
            throw new Error(data?.error || `HTTP ${res.status}`);
        }

        if (data && data.ok === false) {
            throw new Error(data.error || "Error");
        }

        return data;
    }

    async function loadKpis(nextFilters = filters) {
        try {
            setKpisLoading(true);
            const qs = buildQuery(nextFilters || {});
            const data = await safeJson(`${API_BASE}/affiliate_companies_kpis.php${qs}`, {
                headers: authHeaders(),
            });
            setKpis(data.summary || data.kpis || null);
        } catch (e) {
            setKpis(null);
            setToast({ type: "error", msg: e.message });
        } finally {
            setKpisLoading(false);
        }
    }

    async function loadPipeline(nextFilters = filters) {
        setPipelineLoading(true);
        try {
            const qs = buildQuery(nextFilters || {});
            const data = await safeJson(`${API_BASE}/affiliation_pipeline_get.php${qs}`, {
                headers: authHeaders(),
            });
            setPipelineData(data || null);
        } catch (e) {
            console.warn("affiliation_pipeline_get error", e);
            setPipelineData(null);
        } finally {
            setPipelineLoading(false);
        }
    }

    async function loadPmUsers() {
        if (!canAdmin) return;
        try {
            const data = await safeJson(`${API_BASE}/users_pm_list.php`, {
                headers: authHeaders(),
            });
            setPmUsers(data.users || []);
        } catch { }
    }

    async function loadIndustries() {
        try {
            const res = await fetch(`${API_BASE}/industries_list.php`, {
                headers: authHeaders(),
            });
            const txt = await res.text();
            const data = txt ? JSON.parse(txt) : [];
            const list = Array.isArray(data) ? data : data.industries || [];
            setIndustries(list);
        } catch { }
    }

    async function loadMasterContacts() {
        try {
            setMasterContactsLoading(true);
            const data = await safeJson(`${API_BASE}/contacts_list.php`, {
                headers: authHeaders(),
            });
            setMasterContacts(Array.isArray(data) ? data : data.rows || data.companies || data.items || []);
        } catch (e) {
            setMasterContacts([]);
            setToast({ type: "error", msg: e.message });
        } finally {
            setMasterContactsLoading(false);
        }
    }

    function mergeRegions(list) {
        setRegionsOptions((prev) => {
            const set = new Set(prev.filter(Boolean));
            for (const r of list || []) {
                if (r?.region) set.add(r.region);
            }
            return ["", ...Array.from(set).sort()];
        });
    }

    async function loadRegionsCatalog(baseFilters = {}) {
        try {
            const qs = buildQuery({
                ...baseFilters,
                region: "",
                name: "",
                city: "",
                phone: "",
                email: "",
                rubro: "",
                status: "",
                industry_id: "",
                pm_user_id: "",
            });

            const data = await safeJson(`${API_BASE}/affiliate_companies_list.php${qs}`, {
                headers: authHeaders(),
            });

            const arr = Array.isArray(data) ? data : data.rows || data.companies || data.items || [];
            mergeRegions(arr);
        } catch { }
    }

    async function loadSections(industryId) {
        if (!industryId) {
            setSections([]);
            return;
        }

        setSectionsLoading(true);
        try {
            const res = await fetch(
                `${API_BASE}/industry_sections_list.php?industry_id=${industryId}`,
                { headers: authHeaders() }
            );
            const txt = await res.text();
            const data = txt ? JSON.parse(txt) : [];
            const list = Array.isArray(data) ? data : data.sections || [];
            setSections(list);
        } catch (e) {
            setSections([]);
            setToast({ type: "error", msg: e.message });
        } finally {
            setSectionsLoading(false);
        }
    }

    async function loadListWith(nextFilters) {
        setLoading(true);
        try {
            const qs = buildQuery(nextFilters);
            const data = await safeJson(`${API_BASE}/affiliate_companies_list.php${qs}`, {
                headers: authHeaders(),
            });
            const arr = Array.isArray(data) ? data : data.rows || data.companies || data.items || [];
            setRows(arr);
            mergeRegions(arr);

            if (selectedCompany?.id) {
                const freshSelected = arr.find((x) => String(x.id) === String(selectedCompany.id));
                if (freshSelected) {
                    setSelectedCompany(freshSelected);
                }
            }

            await loadKpis(nextFilters);
            await loadPipeline(nextFilters);
        } catch (e) {
            setToast({ type: "error", msg: e.message });
        } finally {
            setLoading(false);
        }
    }

    async function loadList() {
        await loadListWith(filters);
    }

    async function loadActivities(companyId) {
        if (!companyId) {
            setActivities([]);
            return;
        }

        setActivitiesLoading(true);
        try {
            const data = await safeJson(
                `${API_BASE}/affiliate_company_activities_list.php?company_id=${companyId}`,
                { headers: authHeaders() }
            );
            setActivities(Array.isArray(data) ? data : data.items || []);
        } catch (e) {
            setActivities([]);
            setToast({ type: "error", msg: e.message });
        } finally {
            setActivitiesLoading(false);
        }
    }

    async function loadCompanyContacts(companyId) {
        if (!companyId) {
            setCompanyContacts([]);
            return;
        }

        setCompanyContactsLoading(true);
        try {
            const data = await safeJson(
                `${API_BASE}/affiliate_company_contacts_list.php?company_id=${companyId}`,
                { headers: authHeaders() }
            );
            setCompanyContacts(Array.isArray(data) ? data : data.items || []);
        } catch (e) {
            setCompanyContacts([]);
            setToast({ type: "error", msg: e.message });
        } finally {
            setCompanyContactsLoading(false);
        }
    }

    async function attachContactToCompany(companyId, contactId) {
        if (!canEdit) {
            setToast({ type: "error", msg: "No tienes permiso para vincular contactos" });
            return;
        }

        if (!companyId || !contactId) {
            setToast({ type: "error", msg: "Selecciona un contacto del catálogo maestro" });
            return;
        }

        try {
            setLinkingContact(true);

            await safeJson(`${API_BASE}/affiliate_company_contact_attach.php`, {
                method: "POST",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify({
                    company_id: companyId,
                    contact_id: Number(contactId),
                }),
            });

            setToast({ type: "ok", msg: "Contacto vinculado" });
            setContactPickerId("");
            await loadCompanyContacts(companyId);
        } catch (e) {
            setToast({ type: "error", msg: e.message });
        } finally {
            setLinkingContact(false);
        }
    }

    async function detachContactFromCompany(linkId, companyId) {
        if (!canEdit) {
            setToast({ type: "error", msg: "No tienes permiso para desvincular contactos" });
            return;
        }

        if (!window.confirm("¿Desvincular este contacto de la empresa?")) return;

        try {
            setLinkingContact(true);

            await safeJson(`${API_BASE}/affiliate_company_contact_detach.php`, {
                method: "POST",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify({ id: linkId }),
            });

            setToast({ type: "ok", msg: "Contacto desvinculado" });
            await loadCompanyContacts(companyId);
        } catch (e) {
            setToast({ type: "error", msg: e.message });
        } finally {
            setLinkingContact(false);
        }
    }

    function resetActivityForm() {
        setActivityEditId(null);
        setActivityForm({
            type: "email_enviado",
            channel: "email",
            subject: "",
            description: "",
        });
    }

    function openCompanyPanel(row, mode = "detail") {
        if (!row?.id) return;

        const tab = mode === "contacts"
            ? "?tab=contactos"
            : mode === "activities"
                ? "?tab=actividades"
                : "";

        navigate(`/affiliate-companies/${row.id}${tab}`);
    }

    async function quickChangeStatus(row, nextStatus) {
        if (!row?.id || !nextStatus || nextStatus === row.status) return;

        if (!canEdit) {
            setToast({ type: "error", msg: "No tienes permiso para cambiar la etapa del proceso" });
            return;
        }

        try {
            const payload = {
                ...row,
                status: nextStatus,
                industry_id: row.industry_id ? Number(row.industry_id) : null,
                section_id: row.section_id ? Number(row.section_id) : null,
            };

            await safeJson(`${API_BASE}/affiliate_company_update.php`, {
                method: "POST",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify(payload),
            });

            setToast({ type: "ok", msg: `Etapa actualizado a: ${nextStatus}` });
            await loadListWith(filters);
        } catch (e) {
            setToast({ type: "error", msg: e.message });
        }
    }

    async function handleSelectCompany(row, openDetail = false) {
        setSelectedCompany(row);
        resetActivityForm();

        if (openDetail) {
            openCompanyPanel(row, "detail");
            return;
        }

        await Promise.all([
            loadActivities(row.id),
            loadCompanyContacts(row.id),
        ]);
    }

    function startEditActivity(act) {
        setActivityEditId(act.id);
        setActivityForm({
            type: act.type || "email_enviado",
            channel: act.channel || "email",
            subject: act.subject || "",
            description: act.description || "",
        });
    }

    async function saveActivity(e) {
        e.preventDefault();

        if (!selectedCompany?.id) return;

        if (!canEdit) {
            setToast({ type: "error", msg: "No tienes permiso para gestionar actividades" });
            return;
        }

        try {
            setSavingActivity(true);

            const payload = activityEditId
                ? {
                    id: activityEditId,
                    company_id: selectedCompany.id,
                    ...activityForm,
                }
                : {
                    company_id: selectedCompany.id,
                    ...activityForm,
                };

            const endpoint = activityEditId
                ? "affiliate_company_activity_update.php"
                : "affiliate_company_activity_create.php";

            await safeJson(`${API_BASE}/${endpoint}`, {
                method: "POST",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify(payload),
            });

            setToast({
                type: "ok",
                msg: activityEditId ? "Actividad actualizada" : "Actividad guardada",
            });

            resetActivityForm();
            await loadActivities(selectedCompany.id);
        } catch (e2) {
            setToast({ type: "error", msg: e2.message });
        } finally {
            setSavingActivity(false);
        }
    }

    async function deleteActivity(id) {
        if (!canEdit) {
            setToast({ type: "error", msg: "No tienes permiso para eliminar actividades" });
            return;
        }

        if (!window.confirm("¿Eliminar actividad?")) return;

        try {
            await safeJson(`${API_BASE}/affiliate_company_activity_delete.php`, {
                method: "POST",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify({ id }),
            });
            setToast({ type: "ok", msg: "Actividad eliminada" });
            if (selectedCompany?.id) {
                await loadActivities(selectedCompany.id);
            }
            if (activityEditId === id) resetActivityForm();
        } catch (e) {
            setToast({ type: "error", msg: e.message });
        }
    }

    async function handleImportSubmit(e) {
        e.preventDefault();

        if (!importFile) {
            setToast({ type: "error", msg: "Selecciona un archivo para importar" });
            return;
        }

        try {
            setImporting(true);

            const token = localStorage.getItem("cani_auth") || "";
            const fd = new FormData();
            fd.append("file", importFile);

            const res = await fetch(`${API_BASE}/affiliate_companies_import.php`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${token}`,
                    "X-CANI-AUTH": token,
                },
                body: fd,
            });

            const txt = await res.text();
            let data = {};
            try {
                data = txt ? JSON.parse(txt) : {};
            } catch {
                throw new Error(`Respuesta no JSON: ${txt.slice(0, 300)}`);
            }

            console.log("IMPORT STATUS:", res.status);
            console.log("IMPORT RESPONSE:", data);

            if (!res.ok || data.success === false) {
                throw new Error(data.detail || data.error || "No se pudo importar el archivo.");
            }

            const sheetSummary = Array.isArray(data.sheets)
                ? data.sheets
                    .map(
                        (s) =>
                            `${s.sheet}: procesadas ${s.processed || 0}, insertadas ${s.inserted || 0}, omitidas ${s.skipped || 0}`
                    )
                    .join(" | ")
                : "";

            setToast({
                type: "ok",
                msg:
                    `Importación completada. Procesadas: ${data.processed || 0}. ` +
                    `Insertadas: ${data.inserted || 0}. ` +
                    `Omitidas: ${data.skipped || 0}.` +
                    (sheetSummary ? ` Detalle por hoja: ${sheetSummary}` : ""),
            });

            setImportOpen(false);
            setImportFile(null);
            await loadList();
            await loadRegionsCatalog(filters);
        } catch (e2) {
            console.error("IMPORT ERROR:", e2);
            setToast({ type: "error", msg: e2.message });
        } finally {
            setImporting(false);
        }
    }
    useEffect(() => {
        loadList();
        loadKpis(filters);
        loadPmUsers();
        loadIndustries();
        loadRegionsCatalog(filters);
        loadMasterContacts();
    }, []);

    useEffect(() => {
        if (!canAdmin) return;
        loadRegionsCatalog(filters);
    }, [filters.pm_user_id]);

    const syncScroll = (source) => {
        if (syncingScrollRef.current) return;
        syncingScrollRef.current = true;

        if (source === "top" && topScrollRef.current && bottomScrollRef.current) {
            bottomScrollRef.current.scrollLeft = topScrollRef.current.scrollLeft;
        } else if (source === "bottom" && topScrollRef.current && bottomScrollRef.current) {
            topScrollRef.current.scrollLeft = bottomScrollRef.current.scrollLeft;
        }

        requestAnimationFrame(() => {
            syncingScrollRef.current = false;
        });
    };

    const statusCounts = useMemo(() => {
        const map = {};
        for (const r of rows) {
            const s = r.status || "";
            if (!s) continue;
            map[s] = (map[s] || 0) + 1;
        }
        return map;
    }, [rows]);

    const pipelineSummary = pipelineData?.summary || {};
    const pipelineStages = useMemo(() => {
        const list = pipelineData?.stages || [];
        return Array.isArray(list) ? list : [];
    }, [pipelineData]);

    function getSortValue(row, key) {
        switch (key) {
            case "name":
                return row.name || "";
            case "region":
                return row.region || "";
            case "city":
                return row.city || "";
            case "status":
                return row.status || "";
            case "industry":
                return getIndustryDisplay(row) || row.industry_name || row.sector_text || "";
            case "pm":
                return row.pm_display_name || row.pm_iniciales || "";
            case "email":
                return row.email || "";
            case "phone":
                return row.phone || "";
            case "contacts_count":
                return Number(row.contacts_count || 0);
            case "activities_count":
                return Number(row.activities_count || 0);
            default:
                return row[key] || "";
        }
    }

    const sortedRows = useMemo(() => {
        const list = [...rows];
        const { key, direction } = sortConfig || {};
        if (!key) return list;

        list.sort((a, b) => {
            const av = getSortValue(a, key);
            const bv = getSortValue(b, key);

            if (typeof av === "number" || typeof bv === "number") {
                return direction === "asc" ? Number(av) - Number(bv) : Number(bv) - Number(av);
            }

            const result = String(av).localeCompare(String(bv), "es", {
                sensitivity: "base",
                numeric: true,
            });

            return direction === "asc" ? result : -result;
        });

        return list;
    }, [rows, sortConfig]);

    const attentionFilterLabel = {
        sin_contacto: "Sin contacto",
        sin_actividad: "Sin actividad",
        sin_pm: "Sin PM",
    };

    const visibleRows = useMemo(() => {
        if (!attentionFilter) return sortedRows;

        return sortedRows.filter((r) => {
            if (attentionFilter === "sin_contacto") return Number(r.contacts_count || 0) === 0;
            if (attentionFilter === "sin_actividad") return Number(r.activities_count || 0) === 0;
            if (attentionFilter === "sin_pm") return !r.pm_user_id;
            return true;
        });
    }, [sortedRows, attentionFilter]);

    function requestSort(key) {
        setSortConfig((prev) => {
            if (prev?.key === key) {
                return { key, direction: prev.direction === "asc" ? "desc" : "asc" };
            }
            return { key, direction: "asc" };
        });
    }

    function SortHeader({ label, sortKey, align = "left" }) {
        const active = sortConfig?.key === sortKey;
        const icon = active ? (sortConfig.direction === "asc" ? "▲" : "▼") : "↕";

        return (
            <button
                type="button"
                onClick={() => requestSort(sortKey)}
                className={`w-full flex items-center gap-1 ${align === "right" ? "justify-end" : "justify-start"} text-[11px] font-semibold text-[#d7e8f6] hover:text-cani-primary`}
                title={`Ordenar por ${label}`}
            >
                <span>{label}</span>
                <span className={active ? "text-cani-primary" : "text-gray-400"}>{icon}</span>
            </button>
        );
    }


    const kpiCards = useMemo(() => {
        const s = kpis || {};
        return [
            { label: "Total empresas", value: s.total ?? s.total_companies ?? rows.length, hint: "Base activa", tone: "blue" },
            { label: "Prospectos", value: s.prospectos ?? 0, hint: "Inicio de pipeline", tone: "slate" },
            { label: "Contactadas", value: s.contactadas ?? 0, hint: "Email, teléfono o videollamada", tone: "blue" },
            { label: "Interés institucional", value: s.interes_institucional ?? s.aceptaron_cdp ?? 0, hint: "Interés validado", tone: "indigo" },
            { label: "Documentos pendientes", value: s.documentos_pendientes ?? 0, hint: "Documentación solicitada", tone: "purple" },
            { label: "Registro iniciado", value: s.registro_iniciado ?? 0, hint: "Proceso abierto", tone: "amber" },
            { label: "Pago pendiente", value: s.pago_pendiente ?? 0, hint: "Afiliado sin pago / pago pendiente", tone: "orange" },
            { label: "Afiliados activos", value: s.afiliados_activos ?? 0, hint: "Con o sin estrategia", tone: "green" },
            { label: "Sin contacto", value: s.sin_contacto ?? 0, hint: "Falta contacto vinculado", tone: (s.sin_contacto || 0) > 0 ? "red" : "green", filterKey: "sin_contacto" },
            { label: "Sin actividad", value: s.sin_actividad ?? 0, hint: "Sin historial de seguimiento", tone: (s.sin_actividad || 0) > 0 ? "red" : "green", filterKey: "sin_actividad" },
            { label: "Sin PM", value: s.sin_pm ?? 0, hint: "Falta responsable", tone: (s.sin_pm || 0) > 0 ? "amber" : "green", filterKey: "sin_pm" },
            { label: "Score promedio", value: `${Math.round(Number(s.score_promedio || s.avg_score || 0))}/100`, hint: "Calidad de afiliación", tone: Number(s.score_promedio || s.avg_score || 0) >= 70 ? "green" : Number(s.score_promedio || s.avg_score || 0) >= 45 ? "amber" : "red" },
        ];
    }, [kpis, rows.length]);

    function kpiToneClass(tone) {
        const map = {
            blue: "border-[#0ea5e9]/45 bg-[#0b2740] text-[#7dd3fc]",
            green: "border-[#10b981]/40 bg-[#0a332e] text-[#7cebd0]",
            red: "border-[#ef4444]/40 bg-[#2b1117] text-[#fca5a5]",
            amber: "border-[#d4af37]/45 bg-[#3a3110] text-[#f6d76b]",
            orange: "border-[#f97316]/40 bg-[#3b2413] text-[#fdba74]",
            purple: "border-[#8b5cf6]/40 bg-[#24163d] text-[#c4b5fd]",
            indigo: "border-[#6366f1]/40 bg-[#1e1b4b] text-[#c7d2fe]",
            slate: "border-[#24537a] bg-[#08233d] text-[#d9e8f5]",
        };
        return map[tone] || map.slate;
    }

    const filteredMasterContacts = useMemo(() => {
        const q = contactSearch.trim().toLowerCase();
        const linkedIds = new Set(companyContacts.map((c) => String(c.contact_id || c.id)));

        return masterContacts.filter((c) => {
            const id = String(c.id);
            if (linkedIds.has(id)) return false;

            if (!q) return true;

            return [
                getContactDisplayName(c),
                c.email,
                c.mobile,
                c.phone,
                c.position,
                c.account_name,
            ]
                .filter(Boolean)
                .some((v) => String(v).toLowerCase().includes(q));
        });
    }, [masterContacts, companyContacts, contactSearch]);

    function openNew() {
        if (!canCreate) return;

        setDraft({
            id: null,
            name: "",
            status: "Prospecto",
            region: "",
            city: "",
            sector_text: "",
            address: "",
            phone: "",
            email: "",
            website: "",
            notes: "",
            industry_id: "",
            section_id: "",
            pm_user_id: canAdmin ? "" : undefined,
        });

        setSections([]);
        setStructureItems([]);
        setStructureEdit(null);
        setStructureDraft({
            role_title: "",
            person_name: "",
            email: "",
            phone: "",
            notes: "",
        });
        setCompanyContacts([]);
        setContactPickerId("");
        setContactSearch("");
        setDetailMode("detail");
        setModalOpen(true);
    }

    async function openEdit(row, mode = "detail") {
        if (!canEdit) return;

        const next = {
            ...row,
            status: row.status || "Prospecto",
            industry_id: row.industry_id ? String(row.industry_id) : "",
            section_id: row.section_id ? String(row.section_id) : "",
        };

        setDraft(next);
        setDetailMode(mode || "detail");
        setContactPickerId("");
        setContactSearch("");
        setModalOpen(true);

        await Promise.all([
            loadSections(next.industry_id),
            loadCompanyContacts(next.id),
            loadActivities(next.id),
        ]);

        if (ACTIVE_STATUSES.has(row.status)) {
            await loadStructure(row.id);
        } else {
            setStructureItems([]);
        }
    }

    async function saveCompany() {
        if (!draft?.id && !canCreate) {
            setToast({ type: "error", msg: "No tienes permiso para crear empresas objetivo" });
            return;
        }

        if (draft?.id && !canEdit) {
            setToast({ type: "error", msg: "No tienes permiso para editar empresas objetivo" });
            return;
        }

        try {
            if (!draft?.name?.trim()) throw new Error("Nombre requerido");

            const payload = {
                ...draft,
                status: draft.status || "Prospecto",
                industry_id: draft.industry_id ? Number(draft.industry_id) : null,
                section_id: draft.section_id ? Number(draft.section_id) : null,
            };

            if (payload.id) {
                await safeJson(`${API_BASE}/affiliate_company_update.php`, {
                    method: "POST",
                    headers: authHeaders({ "Content-Type": "application/json" }),
                    body: JSON.stringify(payload),
                });
            } else {
                await safeJson(`${API_BASE}/affiliate_company_create.php`, {
                    method: "POST",
                    headers: authHeaders({ "Content-Type": "application/json" }),
                    body: JSON.stringify(payload),
                });
            }

            setToast({ type: "ok", msg: "Guardado" });
            setModalOpen(false);
            await loadList();
        } catch (e) {
            setToast({ type: "error", msg: e.message });
        }
    }

    async function deleteCompany(id) {
        if (!canDelete) {
            setToast({ type: "error", msg: "No tienes permiso para eliminar empresas objetivo" });
            return;
        }

        if (!window.confirm("¿Eliminar empresa?")) return;

        try {
            await safeJson(`${API_BASE}/affiliate_company_delete.php`, {
                method: "POST",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify({ id }),
            });

            setToast({ type: "ok", msg: "Eliminado" });

            if (selectedCompany?.id === id) {
                setSelectedCompany(null);
                setActivities([]);
                setCompanyContacts([]);
            }

            setModalOpen(false);
            await loadList();
        } catch (e) {
            setToast({ type: "error", msg: e.message });
        }
    }

    async function loadStructure(companyId) {
        setStructureLoading(true);
        try {
            const data = await safeJson(
                `${API_BASE}/affiliate_company_structure_list.php?company_id=${companyId}`,
                { headers: authHeaders() }
            );
            setStructureItems(data.items || []);
        } catch (e) {
            setStructureItems([]);
            setToast({ type: "error", msg: e.message });
        } finally {
            setStructureLoading(false);
        }
    }

    async function saveStructure() {
        if (!canEdit) {
            setToast({ type: "error", msg: "No tienes permiso para editar estructura del afiliado" });
            return;
        }

        if (!draft?.id) return;

        try {
            const base = structureEdit ? { ...structureEdit } : { ...structureDraft };
            if (!base.role_title?.trim()) throw new Error("Rol requerido");

            const payload = structureEdit
                ? { ...base, id: structureEdit.id }
                : { ...base, company_id: draft.id };

            const url = structureEdit
                ? "affiliate_company_structure_update.php"
                : "affiliate_company_structure_create.php";

            await safeJson(`${API_BASE}/${url}`, {
                method: "POST",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify(payload),
            });

            setToast({ type: "ok", msg: "Estructura guardada" });
            setStructureDraft({
                role_title: "",
                person_name: "",
                email: "",
                phone: "",
                notes: "",
            });
            setStructureEdit(null);
            await loadStructure(draft.id);
        } catch (e) {
            setToast({ type: "error", msg: e.message });
        }
    }

    async function deleteStructure(id) {
        if (!canEdit) {
            setToast({ type: "error", msg: "No tienes permiso para eliminar estructura del afiliado" });
            return;
        }

        if (!window.confirm("¿Eliminar elemento de estructura?")) return;

        try {
            await safeJson(`${API_BASE}/affiliate_company_structure_delete.php`, {
                method: "POST",
                headers: authHeaders({ "Content-Type": "application/json" }),
                body: JSON.stringify({ id }),
            });
            setToast({ type: "ok", msg: "Eliminado" });
            await loadStructure(draft.id);
        } catch (e) {
            setToast({ type: "error", msg: e.message });
        }
    }

    return (
        <MainLayout>
            <GridRowsProStyle />
            <div className="affiliates-pro min-h-screen bg-[#041426] px-3 py-6 md:px-6 md:py-8 space-y-6 grid-rows-pro">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                    <div>
                        <h2 className="text-lg md:text-xl font-semibold text-white">
                            Afiliaciones PRO · Cámaras y Organismos
                        </h2>
                        <p className="text-xs md:text-sm text-[#9fc4df]">
                            Vista principal del proceso de vinculación institucional; KPIs y status quedan como paneles opcionales.
                        </p>
                    </div>
                    <div className="flex items-center gap-2">
                        <button
                            className="px-3 py-1.5 rounded-lg border border-[#0b4d78] text-[#d9e8f5] text-xs hover:bg-[#10324f]"
                            onClick={() => loadList()}
                        >
                            Recargar
                        </button>

                        {canCreate ? (
                            <button
                                className="px-3 py-1.5 rounded-lg border border-[#0b4d78] text-[#d9e8f5] text-xs hover:bg-[#10324f]"
                                onClick={() => setImportOpen(true)}
                            >
                                Importar
                            </button>
                        ) : null}

                        {canCreate ? (
                            <button
                                className="px-3 py-1.5 rounded-lg bg-[#d4af37] text-white text-xs hover:bg-[#d4af37]Light"
                                onClick={openNew}
                            >
                                + Nueva empresa
                            </button>
                        ) : null}
                    </div>
                </div>

                {affiliationInsightView === "kpis" ? (
                    <div className="bg-[#04192b] border border-[#0b4d78] rounded-xl shadow-sm p-3 space-y-3">
                        <div className="flex items-start justify-between gap-3">
                            <div>
                                <h3 className="text-xs font-semibold text-white">KPIs de afiliación</h3>
                                <p className="text-[10px] text-[#9fc4df]">
                                    Lectura ejecutiva de calidad de captura, disciplina de seguimiento y alertas operativas.
                                </p>
                            </div>
                            <span className="text-[10px] text-[#9fc4df]">
                                {kpisLoading ? "Actualizando..." : "Panel opcional"}
                            </span>
                        </div>

                        <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-6 gap-2">
                            {kpiCards.map((k) => {
                                const clickable = !!k.filterKey;
                                const activeKpi = attentionFilter === k.filterKey;

                                return (
                                    <button
                                        key={k.label}
                                        type="button"
                                        onClick={() => {
                                            if (!clickable) return;
                                            setAttentionFilter(activeKpi ? "" : k.filterKey);
                                        }}
                                        className={`text-left rounded-xl border p-3 shadow-sm ${kpiToneClass(k.tone)} ${clickable ? "hover:shadow-md cursor-pointer" : "cursor-default"} ${activeKpi ? "ring-2 ring-cani-primary" : ""}`}
                                        title={clickable ? "Click para ver cámaras/organismos de este KPI" : ""}
                                    >
                                        <div className="text-[10px] opacity-80">{k.label}</div>
                                        <div className="text-xl font-semibold mt-1">{k.value}</div>
                                        <div className="text-[10px] opacity-70 mt-1">{k.hint}</div>
                                    </button>
                                );
                            })}
                        </div>

                        <div className="border-t border-[#0b4d78] pt-3">
                            <div className="text-[10px] uppercase tracking-[.16em] text-[#8fb9da] font-black mb-2">
                                Enfoque de atención
                            </div>
                            <div className="flex flex-wrap gap-2 text-[11px]">
                                <button
                                    type="button"
                                    onClick={() => setAttentionFilter(attentionFilter === "sin_contacto" ? "" : "sin_contacto")}
                                    className={`px-3 py-1.5 rounded-lg border ${attentionFilter === "sin_contacto" ? "bg-[#38161c] border-[#ef4444]/40 text-[#fca5a5]" : "border-[#0b4d78] text-[#d9e8f5] hover:bg-[#10324f]"}`}
                                >
                                    Sin contacto
                                </button>
                                <button
                                    type="button"
                                    onClick={() => setAttentionFilter(attentionFilter === "sin_actividad" ? "" : "sin_actividad")}
                                    className={`px-3 py-1.5 rounded-lg border ${attentionFilter === "sin_actividad" ? "bg-[#38161c] border-[#ef4444]/40 text-[#fca5a5]" : "border-[#0b4d78] text-[#d9e8f5] hover:bg-[#10324f]"}`}
                                >
                                    Sin actividad
                                </button>
                                <button
                                    type="button"
                                    onClick={() => setAttentionFilter(attentionFilter === "sin_pm" ? "" : "sin_pm")}
                                    className={`px-3 py-1.5 rounded-lg border ${attentionFilter === "sin_pm" ? "bg-[#3a3110] border-[#d4af37]/45 text-[#f6d76b]" : "border-[#0b4d78] text-[#d9e8f5] hover:bg-[#10324f]"}`}
                                >
                                    Sin responsable
                                </button>
                                {attentionFilter ? (
                                    <button
                                        type="button"
                                        onClick={() => setAttentionFilter("")}
                                        className="px-3 py-1.5 rounded-lg border border-[#0b4d78] text-[#d9e8f5] hover:bg-[#10324f]"
                                    >
                                        Limpiar enfoque
                                    </button>
                                ) : null}
                            </div>
                            {attentionFilter ? (
                                <div className="mt-2 text-[11px] text-[#d7e8f6]">
                                    Mostrando: <strong>{attentionFilterLabel[attentionFilter]}</strong> · {visibleRows.length} cámara(s)/organismo(s)
                                </div>
                            ) : null}
                        </div>
                    </div>
                ) : null}

                <div className="bg-[#04192b] border border-[#0b4d78] rounded-[24px] shadow-sm p-4 text-xs space-y-4">
                    <div className="flex flex-wrap items-start justify-between gap-3">
                        <div>
                            <div className="text-[11px] uppercase tracking-[.24em] text-[#d4af37] font-black">
                                Proceso de Vinculación Institucional
                            </div>
                            <h3 className="text-white font-black text-[22px] mt-1 leading-tight">
                                Pipeline de Cámaras y Organismos
                            </h3>
                            <p className="text-[#9fc4df] text-[11px] mt-1 max-w-[760px]">
                                Lectura directa del proceso: etapa, responsable, seguimiento, días en etapa y acción sugerida por cámara u organismo.
                            </p>
                        </div>

                        <div className="flex items-center gap-2 flex-wrap justify-end">
                            <button
                                type="button"
                                onClick={() => setAffiliationInsightView(affiliationInsightView === "kpis" ? "pipeline" : "kpis")}
                                className={`px-4 py-2 rounded-xl border text-[11px] font-black ${affiliationInsightView === "kpis" ? "bg-[#d4af37] text-[#061a2f] border-[#d4af37]" : "bg-[#08233d] text-[#d7e8f6] border-[#0b4d78]"}`}
                                title="Mostrar u ocultar KPIs de afiliación"
                            >
                                ◉ KPIs
                            </button>
                            <button
                                type="button"
                                onClick={() => setAffiliationInsightView(affiliationInsightView === "status" ? "pipeline" : "status")}
                                className={`px-4 py-2 rounded-xl border text-[11px] font-black ${affiliationInsightView === "status" ? "bg-[#d4af37] text-[#061a2f] border-[#d4af37]" : "bg-[#08233d] text-[#d7e8f6] border-[#0b4d78]"}`}
                                title="Mostrar u ocultar status operativos"
                            >
                                ◇ Status
                            </button>
                            <span className="hidden md:inline-block h-6 w-px bg-[#0b4d78]" />
                            <button
                                type="button"
                                onClick={() => setPipelineView("kanban")}
                                className={`px-4 py-2 rounded-xl border text-[11px] font-black ${pipelineView === "kanban" ? "bg-[#d4af37] text-[#061a2f] border-[#d4af37]" : "bg-[#08233d] text-[#d7e8f6] border-[#0b4d78]"}`}
                            >
                                ▦ Kanban
                            </button>
                            <button
                                type="button"
                                onClick={() => setPipelineView("funnel")}
                                className={`px-4 py-2 rounded-xl border text-[11px] font-black ${pipelineView === "funnel" ? "bg-[#d4af37] text-[#061a2f] border-[#d4af37]" : "bg-[#08233d] text-[#d7e8f6] border-[#0b4d78]"}`}
                            >
                                ▰ Embudo
                            </button>
                        </div>
                    </div>

                    <div className="flex flex-wrap gap-2">
                        {[
                            ["En proceso", pipelineSummary.total || 0, "Pipeline activo"],
                            ["Afiliadas", pipelineSummary.won || 0, "Ya forman parte del ecosistema"],
                            ["Requieren atención", pipelineSummary.attention ?? pipelineSummary.stalled ?? 0, "Cards con alerta crítica"],
                            ["Sin seguimiento", pipelineSummary.no_activity || 0, "Sin actividad registrada"],
                            ["Sin responsable", pipelineSummary.no_pm || 0, "Sin PM asignado"],
                            ["Días prom.", `${pipelineSummary.avg_cycle_days || 0}d`, "Promedio desde alta"],
                            ["Avance a afiliación", `${pipelineSummary.conversion_rate || 0}%`, "Afiliadas / proceso"],
                        ].map(([label, value, hint]) => (
                            <div key={label} className="rounded-2xl border border-[#0b4d78] bg-[#061f35] px-3 py-2 min-w-[138px]">
                                <div className="text-[9px] uppercase tracking-[.16em] text-[#8fb9da] font-black">{label}</div>
                                <div className="text-white text-[18px] font-black leading-tight mt-1">{value}</div>
                                <div className="text-[#9fc4df] text-[9px] mt-0.5">{hint}</div>
                            </div>
                        ))}
                    </div>

                    {affiliationInsightView === "status" ? (
                        <div className="rounded-2xl border border-[#0b4d78] bg-[#061f35] p-3 text-[11px] space-y-2">
                            <div className="flex flex-wrap gap-2 items-center justify-between">
                                <span className="font-semibold text-white">Status operativo</span>
                                <div className="flex items-center gap-2">
                                    <span className="text-[#9fc4df]">Capa secundaria para filtrar el listado</span>
                                    <button
                                        className="px-2 py-1 rounded-lg border border-[#0b4d78] text-[11px] hover:bg-[#10324f]"
                                        type="button"
                                        onClick={async () => {
                                            const nextFilters = { ...filters, status: "" };
                                            setFilters(nextFilters);
                                            await loadListWith(nextFilters);
                                        }}
                                    >
                                        Limpiar
                                    </button>
                                </div>
                            </div>

                            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-2 text-[10px]">
                                {STATUS_OPTIONS.map((s) => {
                                    const c = statusCounts[s] || 0;
                                    const active = filters.status === s;
                                    const st = getStatusStyle(s, active);

                                    return (
                                        <button
                                            key={s}
                                            type="button"
                                            onClick={async () => {
                                                const nextFilters = { ...filters, status: active ? "" : s };
                                                setFilters(nextFilters);
                                                await loadListWith(nextFilters);
                                            }}
                                            className="rounded-[22px] p-3 text-left border shadow-sm"
                                            style={{
                                                background: st.background,
                                                borderColor: st.borderColor,
                                                boxShadow: st.boxShadow,
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width: 28,
                                                    height: 4,
                                                    borderRadius: 999,
                                                    background: st.accent,
                                                    marginBottom: 8,
                                                }}
                                            />
                                            <div className="text-[#9fc4df]" style={{ minHeight: 28 }}>
                                                {s}
                                            </div>
                                            <div className="text-lg font-semibold text-white mt-1">{c}</div>
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                    ) : null}

                    {pipelineLoading ? (
                        <div className="rounded-xl border border-[#0b4d78] bg-[#061f35] p-4 text-[#9fc4df]">
                            Actualizando pipeline...
                        </div>
                    ) : pipelineStages.length === 0 ? (
                        <div className="rounded-xl border border-[#0b4d78] bg-[#061f35] p-4 text-[#9fc4df]">
                            No hay etapas configuradas para mostrar. El endpoint debe devolver etapas de fallback aunque el SQL aún no exista.
                        </div>
                    ) : pipelineView === "kanban" ? (
                        <div className="overflow-x-auto pb-2">
                            <div
                                className="grid gap-3"
                                style={{
                                    gridTemplateColumns: `repeat(${Math.max(pipelineStages.length, 1)}, minmax(255px, 1fr))`,
                                    minWidth: Math.max(pipelineStages.length, 1) * 255,
                                }}
                            >
                                {pipelineStages.map((stage, idx) => {
                                    const accent = pipelineStageAccent(stage, idx);
                                    const companies = stage.companies || [];
                                    return (
                                        <div key={stage.stage_key || stage.id || idx} className="rounded-[20px] border border-[#0b4d78] bg-[#061f35] overflow-hidden">
                                            <div className="p-3 border-b border-[#0b4d78]">
                                                <div style={{ background: accent }} className="w-full h-1 rounded-full mb-3" />
                                                <div className="flex items-start justify-between gap-2">
                                                    <div className="min-w-0">
                                                        <div className="text-[#d4af37] text-[10px] font-black">ETAPA {idx + 1}</div>
                                                        <div className="text-white font-black text-sm leading-tight">{stage.stage_name}</div>
                                                        <div className="text-[#9fc4df] text-[10px] mt-1">
                                                            {companies.length} cámara(s) / organismo(s)
                                                        </div>
                                                    </div>
                                                    <div className="text-right shrink-0">
                                                        <div className="text-white font-black text-lg">{stage.share ?? 0}%</div>
                                                        <div className="text-[#9fc4df] text-[9px]">del proceso</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="p-2 space-y-2 max-h-[560px] overflow-auto">
                                                {companies.length === 0 ? (
                                                    <div className="rounded-xl border border-dashed border-[#24587c] p-3 text-[#9fc4df] text-[11px]">
                                                        Sin entidades en esta etapa.
                                                    </div>
                                                ) : companies.map((company) => (
                                                    <button
                                                        key={company.id}
                                                        type="button"
                                                        onClick={() => openCompanyPanel(company, "detail")}
                                                        className="w-full text-left rounded-2xl border border-[#24587c] bg-[#08233d] p-3 hover:bg-[#10324f] transition"
                                                    >
                                                        <div className="flex items-start justify-between gap-2">
                                                            <div className="min-w-0">
                                                                <div className="text-white font-black leading-tight">
                                                                    {company.name}
                                                                </div>
                                                                <div className="mt-2 flex flex-wrap gap-1">
                                                                    <span className="text-[9px] px-2 py-1 rounded-full bg-[#04192b] text-[#d7e8f6] border border-[#0b4d78]">
                                                                        {company.status || "Sin status"}
                                                                    </span>
                                                                    {company.alert_level === "critical" ? (
                                                                        <span className="text-[9px] px-2 py-1 rounded-full bg-[#38161c] text-[#fca5a5] border border-[#ef4444]/40">Requiere atención</span>
                                                                    ) : company.alert_level === "warning" ? (
                                                                        <span className="text-[9px] px-2 py-1 rounded-full bg-[#3a3110] text-[#f6d76b] border border-[#d4af37]/40">Seguimiento cercano</span>
                                                                    ) : (
                                                                        <span className="text-[9px] px-2 py-1 rounded-full bg-[#0b3a36] text-[#7cebd0] border border-[#10b981]/40">En control</span>
                                                                    )}
                                                                    {!company.pm_user_id ? (
                                                                        <span className="text-[9px] px-2 py-1 rounded-full bg-[#38161c] text-[#fca5a5] border border-[#ef4444]/40">Sin responsable</span>
                                                                    ) : null}
                                                                    {(company.activities_count || 0) <= 0 ? (
                                                                        <span className="text-[9px] px-2 py-1 rounded-full bg-[#3a3110] text-[#f6d76b] border border-[#d4af37]/40">Sin seguimiento</span>
                                                                    ) : null}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="grid grid-cols-2 gap-2 mt-3 text-[10px] text-[#9fc4df]">
                                                            <div><strong className="text-[#d7e8f6]">Contacto</strong><br />{company.primary_contact_name || "Sin contacto"}</div>
                                                            <div><strong className="text-[#d7e8f6]">Responsable</strong><br />{company.pm_iniciales || company.pm_display_name || "Sin PM"}</div>
                                                            <div><strong className="text-[#d7e8f6]">Días etapa</strong><br />{daysLabel(company.days_in_stage)}</div>
                                                            <div><strong className="text-[#d7e8f6]">Últ. seguimiento</strong><br />{company.last_activity_at ? compactDate(company.last_activity_at) : "Sin actividad"}</div>
                                                            <div><strong className="text-[#d7e8f6]">Docs</strong><br />{company.documents_count || 0}</div>
                                                            <div><strong className="text-[#d7e8f6]">Score</strong><br />{company.score || 0}/100</div>
                                                        </div>

                                                        <div className="mt-3 rounded-xl border border-[#0b4d78] bg-[#04192b] p-2 text-[10px] text-[#d7e8f6]">
                                                            <span className="text-[#9fc4df]">Acción sugerida:</span><br />
                                                            <strong>{pipelineActionLabel(company.suggested_action)}</strong>
                                                        </div>
                                                    </button>
                                                ))}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    ) : (
                        <div className="space-y-4">
                            <div className="rounded-2xl border border-[#0b4d78] bg-[#061f35] p-4">
                                <div className="text-white font-black text-sm mb-1">Embudo de avance institucional</div>
                                <div className="text-[#9fc4df] text-[11px] mb-4">
                                    Cada barra representa cuántas entidades se encuentran en la etapa. El objetivo es detectar concentración, caída o bloqueo del proceso.
                                </div>

                                <div className="space-y-3">
                                    {pipelineStages.map((stage, idx) => {
                                        const accent = pipelineStageAccent(stage, idx);
                                        const total = Number(pipelineSummary.total || 0);
                                        const count = Number(stage.count || 0);
                                        const pct = total > 0 ? Math.round((count / total) * 100) : 0;
                                        return (
                                            <button
                                                key={stage.stage_key || stage.id || idx}
                                                type="button"
                                                onClick={async () => {
                                                    if (stage.statuses?.length === 1) {
                                                        const nextFilters = { ...filters, status: stage.statuses[0] };
                                                        setFilters(nextFilters);
                                                        await loadListWith(nextFilters);
                                                    }
                                                }}
                                                className="w-full text-left grid grid-cols-[170px_1fr_90px] gap-3 items-center"
                                            >
                                                <div>
                                                    <div className="text-[#d4af37] text-[9px] font-black">ETAPA {idx + 1}</div>
                                                    <div className="text-[#d7e8f6] text-[11px] font-black">{stage.stage_name}</div>
                                                </div>
                                                <div className="h-10 rounded-xl bg-[#04192b] overflow-hidden border border-[#0b4d78] relative">
                                                    {count > 0 ? (
                                                        <div
                                                            className="h-full flex items-center px-3 text-[11px] font-black"
                                                            style={{ width: `${Math.max(pct, 8)}%`, background: accent, color: "#061a2f" }}
                                                        >
                                                            {count} entidad(es)
                                                        </div>
                                                    ) : (
                                                        <div className="h-full flex items-center px-3 text-[11px] font-black text-[#9fc4df]">
                                                            0 entidades
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="text-right">
                                                    <div className="text-white font-black">{pct}%</div>
                                                    <div className="text-[#9fc4df] text-[9px]">del proceso</div>
                                                </div>
                                            </button>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <div className="grid grid-cols-1 gap-3">
                    <div className="bg-[#04192b] border border-[#0b4d78] rounded-xl shadow-sm overflow-hidden">
                        <div className="px-4 py-3 border-b border-[#0b4d78] flex items-center justify-between">
                            <div>
                                <h3 className="text-xs font-semibold text-white">Cámaras y Organismos</h3>
                                <p className="text-[10px] text-[#9fc4df]">
                                    Listado operativo filtrable por etapa, eje, responsable y datos de contacto.
                                </p>
                            </div>
                            <span className="text-[11px] text-[#9fc4df]">
                                {loading ? "Cargando..." : `Total: ${rows.length} · Vista: ${visibleRows.length}`}
                            </span>
                        </div>

                        <div
                            ref={topScrollRef}
                            onScroll={() => syncScroll("top")}
                            style={{
                                overflowX: "auto",
                                overflowY: "hidden",
                                height: 16,
                                borderBottom: "1px solid #eef2f7",
                            }}
                        >
                            <div style={{ width: tableMinWidth, height: 1 }} />
                        </div>

                        <div
                            ref={bottomScrollRef}
                            onScroll={() => syncScroll("bottom")}
                            className="max-h-[64vh] overflow-auto"
                        >
                            <table
                                className="text-xs w-full"
                                style={{
                                    minWidth: tableMinWidth,
                                    tableLayout: "fixed",
                                }}
                            >
                                <colgroup>
                                    <col style={{ width: widths.company }} />
                                    <col style={{ width: widths.region }} />
                                    <col style={{ width: widths.city }} />
                                    <col style={{ width: widths.status }} />
                                    <col style={{ width: widths.industry }} />
                                    <col style={{ width: widths.pm }} />
                                    <col style={{ width: widths.email }} />
                                    <col style={{ width: widths.phone }} />
                                    <col style={{ width: widths.actions }} />
                                </colgroup>

                                <thead className="bg-cani-bg">
                                    <tr className="text-left text-[11px] font-semibold text-[#d7e8f6]">
                                        <th className="px-3 py-2"><SortHeader label="Empresa" sortKey="name" /></th>
                                        <th className="px-3 py-2"><SortHeader label="Región" sortKey="region" /></th>
                                        <th className="px-3 py-2"><SortHeader label="Ciudad" sortKey="city" /></th>
                                        <th className="px-3 py-2"><SortHeader label="Etapa" sortKey="status" /></th>
                                        <th className="px-3 py-2"><SortHeader label="Eje" sortKey="industry" /></th>
                                        <th className="px-3 py-2"><SortHeader label="PM" sortKey="pm" /></th>
                                        <th className="px-3 py-2"><SortHeader label="Email" sortKey="email" /></th>
                                        <th className="px-3 py-2"><SortHeader label="Teléfono" sortKey="phone" /></th>
                                        <th className="px-3 py-2 text-right">Acciones</th>
                                    </tr>

                                    <tr className="border-t border-[#0b4d78]">
                                        <th className="px-3 py-2">
                                            <input
                                                className="w-full border border-[#0b4d78] rounded-lg px-2 py-1 text-[11px] focus:outline-none focus:ring-1 focus:ring-cani-primary"
                                                value={filters.name}
                                                onChange={async (e) => {
                                                    const nextFilters = { ...filters, name: e.target.value };
                                                    setFilters(nextFilters);
                                                    await loadListWith(nextFilters);
                                                }}
                                                placeholder="Filtrar..."
                                            />
                                        </th>
                                        <th className="px-3 py-2">
                                            <select
                                                className="w-full border border-[#0b4d78] rounded-lg px-2 py-1 text-[11px] focus:outline-none focus:ring-1 focus:ring-cani-primary"
                                                value={filters.region}
                                                onChange={async (e) => {
                                                    const nextFilters = { ...filters, region: e.target.value };
                                                    setFilters(nextFilters);
                                                    await loadListWith(nextFilters);
                                                }}
                                            >
                                                {regionsOptions.map((r) => (
                                                    <option key={r || "all"} value={r}>
                                                        {r || "Todas"}
                                                    </option>
                                                ))}
                                            </select>
                                        </th>
                                        <th className="px-3 py-2">
                                            <input
                                                className="w-full border border-[#0b4d78] rounded-lg px-2 py-1 text-[11px] focus:outline-none focus:ring-1 focus:ring-cani-primary"
                                                value={filters.city}
                                                onChange={async (e) => {
                                                    const nextFilters = { ...filters, city: e.target.value };
                                                    setFilters(nextFilters);
                                                    await loadListWith(nextFilters);
                                                }}
                                                placeholder="Filtrar..."
                                            />
                                        </th>
                                        <th className="px-3 py-2">
                                            <select
                                                className="w-full border border-[#0b4d78] rounded-lg px-2 py-1 text-[11px] focus:outline-none focus:ring-1 focus:ring-cani-primary"
                                                value={filters.status}
                                                onChange={async (e) => {
                                                    const nextFilters = { ...filters, status: e.target.value };
                                                    setFilters(nextFilters);
                                                    await loadListWith(nextFilters);
                                                }}
                                            >
                                                <option value="">Todos</option>
                                                {STATUS_OPTIONS.map((s) => (
                                                    <option key={s} value={s}>
                                                        {s}
                                                    </option>
                                                ))}
                                            </select>
                                        </th>
                                        <th className="px-3 py-2">
                                            <select
                                                className="w-full border border-[#0b4d78] rounded-lg px-2 py-1 text-[11px] focus:outline-none focus:ring-1 focus:ring-cani-primary"
                                                value={filters.industry_id}
                                                onChange={async (e) => {
                                                    const nextFilters = { ...filters, industry_id: e.target.value };
                                                    setFilters(nextFilters);
                                                    await loadListWith(nextFilters);
                                                }}
                                            >
                                                <option value="">Todas</option>
                                                {industries.map((i) => (
                                                    <option key={i.id} value={String(i.id)}>
                                                        {i.code || i.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </th>
                                        <th className="px-3 py-2">
                                            {canAdmin ? (
                                                <select
                                                    className="w-full border border-[#0b4d78] rounded-lg px-2 py-1 text-[11px] focus:outline-none focus:ring-1 focus:ring-cani-primary"
                                                    value={filters.pm_user_id}
                                                    onChange={async (e) => {
                                                        const nextFilters = { ...filters, pm_user_id: e.target.value };
                                                        setFilters(nextFilters);
                                                        await loadListWith(nextFilters);
                                                    }}
                                                >
                                                    <option value="">Todos PM</option>
                                                    {pmUsers.map((u) => (
                                                        <option key={u.id} value={String(u.id)}>
                                                            {u.display_name}
                                                        </option>
                                                    ))}
                                                </select>
                                            ) : (
                                                <span className="text-[11px] text-gray-400">—</span>
                                            )}
                                        </th>
                                        <th className="px-3 py-2">
                                            <input
                                                className="w-full border border-[#0b4d78] rounded-lg px-2 py-1 text-[11px] focus:outline-none focus:ring-1 focus:ring-cani-primary"
                                                value={filters.email}
                                                onChange={async (e) => {
                                                    const nextFilters = { ...filters, email: e.target.value };
                                                    setFilters(nextFilters);
                                                    await loadListWith(nextFilters);
                                                }}
                                                placeholder="Filtrar..."
                                            />
                                        </th>
                                        <th className="px-3 py-2">
                                            <input
                                                className="w-full border border-[#0b4d78] rounded-lg px-2 py-1 text-[11px] focus:outline-none focus:ring-1 focus:ring-cani-primary"
                                                value={filters.phone}
                                                onChange={async (e) => {
                                                    const nextFilters = { ...filters, phone: e.target.value };
                                                    setFilters(nextFilters);
                                                    await loadListWith(nextFilters);
                                                }}
                                                placeholder="Filtrar..."
                                            />
                                        </th>
                                        <th className="px-3 py-2 text-right">
                                            <span className="text-[11px] text-gray-400">—</span>
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan={9} className="px-3 py-4 text-center text-[#9fc4df]">
                                                Cargando empresas...
                                            </td>
                                        </tr>
                                    ) : null}

                                    {!loading && visibleRows.length === 0 ? (
                                        <tr>
                                            <td colSpan={9} className="px-3 py-4 text-center text-gray-400">
                                                No hay empresas que cumplan con los filtros seleccionados.
                                            </td>
                                        </tr>
                                    ) : null}

                                    {!loading &&
                                        visibleRows.map((r) => (
                                            <tr
                                                key={r.id}
                                                className={`border-t border-[#0b4d78] hover:bg-[#10324f]/60 cursor-pointer ${selectedCompany?.id === r.id ? "bg-cani-bg/80" : ""
                                                    }`}
                                                onClick={() => handleSelectCompany(r, true)}
                                            >
                                                <td className="px-3 py-2 text-[11px] text-white">
                                                    <div className="font-medium">{r.name}</div>
                                                    {r.sector_text ? (
                                                        <div className="text-[10px] text-[#9fc4df]">{r.sector_text}</div>
                                                    ) : null}
                                                    <div className="flex flex-wrap gap-1 mt-1">
                                                        <span className={`px-1.5 py-0.5 rounded border text-[9px] ${Number(r.contacts_count || 0) > 0 ? "bg-[#0b3a36] border-[#10b981]/40 text-[#7cebd0]" : "bg-[#38161c] border-[#ef4444]/40 text-[#fca5a5]"}`}>
                                                            Contactos: {Number(r.contacts_count || 0)}
                                                        </span>
                                                        <span className={`px-1.5 py-0.5 rounded border text-[9px] ${Number(r.activities_count || 0) > 0 ? "bg-[#0b3a36] border-[#10b981]/40 text-[#7cebd0]" : "bg-[#38161c] border-[#ef4444]/40 text-[#fca5a5]"}`}>
                                                            Actividades: {Number(r.activities_count || 0)}
                                                        </span>
                                                    </div>
                                                </td>
                                                <td className="px-3 py-2 text-[11px] text-[#d7e8f6]">{r.region || "—"}</td>
                                                <td className="px-3 py-2 text-[11px] text-[#d7e8f6]">{r.city || "—"}</td>
                                                <td className="px-3 py-2 text-[11px] text-[#d7e8f6]" title={r.status || ""}>{r.status || "—"}</td>
                                                <td
                                                    className="px-3 py-2 text-[11px] text-[#d7e8f6]"
                                                    title={r.industry_name || ""}
                                                >
                                                    {getIndustryDisplay(r)}
                                                </td>
                                                <td
                                                    className="px-3 py-2 text-[11px] text-[#d7e8f6]"
                                                    title={r.pm_display_name || r.pm_name || ""}
                                                >
                                                    {r.pm_iniciales || "—"}
                                                </td>
                                                <td
                                                    className="px-3 py-2 text-[11px] text-[#d7e8f6] overflow-hidden text-ellipsis whitespace-nowrap"
                                                    title={r.email || ""}
                                                >
                                                    {r.email || "—"}
                                                </td>
                                                <td className="px-3 py-2 text-[11px] text-[#d7e8f6] overflow-hidden text-ellipsis whitespace-nowrap">
                                                    {r.phone || "—"}
                                                </td>
                                                <td className="px-3 py-2 text-right text-[11px] text-[#d7e8f6]">
                                                    <div className="flex flex-col items-end gap-1 text-[10px]">
                                                        {canEdit ? (
                                                            <>
                                                                <div className="grid grid-cols-2 gap-1 w-[200px]">
                                                                    <button
                                                                        type="button"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            openCompanyPanel(r, "activities");
                                                                        }}
                                                                        className="w-full px-2 py-1 rounded-lg border border-[#0b4d78] hover:bg-[#10324f]"
                                                                        title="Registrar o consultar actividades"
                                                                    >
                                                                        Actividades
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            openCompanyPanel(r, "contacts");
                                                                        }}
                                                                        className="w-full px-2 py-1 rounded-lg border border-[#0b4d78] hover:bg-[#10324f]"
                                                                        title="Ver o vincular contactos"
                                                                    >
                                                                        Contactos
                                                                    </button>
                                                                </div>

                                                                <select
                                                                    value={r.status || "Prospecto"}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                    onChange={async (e) => {
                                                                        e.stopPropagation();
                                                                        await quickChangeStatus(r, e.target.value);
                                                                    }}
                                                                    className="w-[200px] border border-[#0b4d78] rounded-lg px-2 py-1 text-[10px] bg-[#04192b]"
                                                                    title="Cambiar etapa del proceso"
                                                                >
                                                                    {STATUS_OPTIONS.map((s) => (
                                                                        <option key={s} value={s}>{s}</option>
                                                                    ))}
                                                                </select>
                                                            </>
                                                        ) : null}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="hidden">
                        <div className="bg-[#04192b] border border-[#0b4d78] rounded-xl shadow-sm overflow-hidden">
                            <div className="px-4 py-3 border-b border-[#0b4d78]">
                                <h3 className="text-xs font-semibold text-white">Contactos vinculados</h3>
                                <p className="text-[10px] text-[#9fc4df]">
                                    Selecciona una empresa para ver y vincular contactos del catálogo maestro.
                                </p>
                            </div>

                            {!selectedCompany ? (
                                <div className="px-4 py-6 text-center text-xs text-gray-400">
                                    Selecciona una empresa del listado para ver sus contactos.
                                </div>
                            ) : (
                                <div className="flex flex-col">
                                    <div className="px-4 py-3 border-b border-[#0b4d78] text-[11px] space-y-1">
                                        <div className="font-semibold text-white">{selectedCompany.name}</div>
                                        <div className="text-[#d7e8f6]">
                                            {companyContactsLoading
                                                ? "Cargando contactos..."
                                                : `${companyContacts.length} contacto(s) vinculado(s)`}
                                        </div>
                                    </div>

                                    <div className="max-h-[28vh] overflow-y-auto">
                                        {companyContactsLoading ? (
                                            <div className="px-4 py-4 text-center text-[11px] text-[#9fc4df]">
                                                Cargando contactos...
                                            </div>
                                        ) : companyContacts.length === 0 ? (
                                            <div className="px-4 py-4 text-center text-[11px] text-gray-400">
                                                Esta empresa aún no tiene contactos vinculados.
                                            </div>
                                        ) : (
                                            <ul className="divide-y divide-cani-border text-[11px]">
                                                {companyContacts.map((c) => (
                                                    <li key={c.id || `${c.company_id}-${c.contact_id}`} className="px-4 py-3">
                                                        <div className="flex items-start justify-between gap-2">
                                                            <div className="min-w-0">
                                                                <div className="font-semibold text-white">
                                                                    {getContactDisplayName(c)}
                                                                </div>
                                                                <div className="text-[#d7e8f6]">
                                                                    {c.position || "Sin puesto"}
                                                                </div>
                                                                <div className="text-[10px] text-[#9fc4df] mt-1">
                                                                    {c.email || "Sin email"} · {c.mobile || c.phone || "Sin teléfono"}
                                                                </div>
                                                            </div>

                                                            {canEdit ? (
                                                                <button
                                                                    type="button"
                                                                    onClick={() =>
                                                                        detachContactFromCompany(
                                                                            c.id,
                                                                            selectedCompany.id
                                                                        )
                                                                    }
                                                                    className="px-2 py-1 rounded-lg border border-[#ef4444]/40 text-[#fca5a5] hover:bg-[#38161c] shrink-0"
                                                                    disabled={linkingContact}
                                                                >
                                                                    Quitar
                                                                </button>
                                                            ) : null}
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>

                                    <div className="border-t border-[#0b4d78] px-4 py-3 text-[11px] space-y-2">
                                        <div className="font-semibold text-white">
                                            Vincular contacto existente
                                        </div>

                                        {canEdit ? (
                                            <>
                                                <input
                                                    type="text"
                                                    value={contactSearch}
                                                    onChange={(e) => setContactSearch(e.target.value)}
                                                    placeholder="Buscar por nombre, email, puesto..."
                                                    className="w-full border border-[#0b4d78] rounded-lg px-2 py-1.5 text-[11px] focus:outline-none focus:ring-1 focus:ring-cani-primary"
                                                />

                                                <select
                                                    value={contactPickerId}
                                                    onChange={(e) => setContactPickerId(e.target.value)}
                                                    className="w-full border border-[#0b4d78] rounded-lg px-2 py-1.5 text-[11px] focus:outline-none focus:ring-1 focus:ring-cani-primary"
                                                    disabled={masterContactsLoading || linkingContact}
                                                >
                                                    <option value="">
                                                        {masterContactsLoading
                                                            ? "Cargando catálogo de contactos..."
                                                            : "-- Selecciona contacto --"}
                                                    </option>
                                                    {filteredMasterContacts.map((c) => (
                                                        <option key={c.id} value={String(c.id)}>
                                                            {getContactDisplayName(c)}
                                                            {c.position ? ` · ${c.position}` : ""}
                                                            {c.email ? ` · ${c.email}` : ""}
                                                        </option>
                                                    ))}
                                                </select>

                                                <div className="flex justify-end">
                                                    <button
                                                        type="button"
                                                        onClick={() =>
                                                            attachContactToCompany(selectedCompany.id, contactPickerId)
                                                        }
                                                        disabled={!contactPickerId || linkingContact}
                                                        className="px-3 py-1.5 rounded-lg bg-[#d4af37] text-white text-[11px] hover:bg-[#d4af37]Light disabled:opacity-60"
                                                    >
                                                        {linkingContact ? "Guardando..." : "Vincular contacto"}
                                                    </button>
                                                </div>
                                            </>
                                        ) : (
                                            <div className="text-[11px] text-gray-400">
                                                No tienes permiso para vincular contactos.
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="bg-[#04192b] border border-[#0b4d78] rounded-xl shadow-sm overflow-hidden">
                            <div className="px-4 py-3 border-b border-[#0b4d78]">
                                <h3 className="text-xs font-semibold text-white">Actividades</h3>
                                <p className="text-[10px] text-[#9fc4df]">
                                    Selecciona una empresa para ver, agregar, editar o eliminar actividades.
                                </p>
                            </div>

                            {!selectedCompany ? (
                                <div className="px-4 py-6 text-center text-xs text-gray-400">
                                    Selecciona una empresa del listado para ver sus actividades.
                                </div>
                            ) : (
                                <div className="flex flex-col h-full">
                                    <div className="px-4 py-3 border-b border-[#0b4d78] text-[11px] space-y-1">
                                        <div className="font-semibold text-white">{selectedCompany.name}</div>
                                        <div className="text-[#d7e8f6]">Etapa: {selectedCompany.status || "—"}</div>
                                        <div className="text-[#d7e8f6]">
                                            Eje: {getIndustryDisplay(selectedCompany)}
                                        </div>
                                        <div className="text-[#d7e8f6]">
                                            PM: {selectedCompany.pm_display_name || selectedCompany.pm_name || "—"}
                                        </div>
                                    </div>

                                    <div className="flex-1 max-h-[34vh] overflow-y-auto">
                                        {activitiesLoading ? (
                                            <div className="px-4 py-4 text-center text-[11px] text-[#9fc4df]">
                                                Cargando actividades...
                                            </div>
                                        ) : activities.length === 0 ? (
                                            <div className="px-4 py-4 text-center text-[11px] text-gray-400">
                                                Aún no hay actividades registradas para esta empresa.
                                            </div>
                                        ) : (
                                            <ul className="divide-y divide-cani-border text-[11px]">
                                                {activities.map((act) => (
                                                    <li key={act.id} className="px-4 py-3">
                                                        <div className="flex justify-between gap-2">
                                                            <div>
                                                                <div className="font-semibold text-white">
                                                                    {act.type} ({act.channel})
                                                                </div>
                                                                {act.subject ? (
                                                                    <div className="text-[#d9e8f5]">{act.subject}</div>
                                                                ) : null}
                                                                {act.description ? (
                                                                    <div className="text-[10px] text-[#d7e8f6] mt-1">
                                                                        {act.description}
                                                                    </div>
                                                                ) : null}
                                                            </div>
                                                            <div className="text-right text-[10px] text-[#9fc4df]">
                                                                {act.user_name ? <div>{act.user_name}</div> : null}
                                                                <div>{act.created_at}</div>
                                                            </div>
                                                        </div>

                                                        {canEdit ? (
                                                            <div className="flex justify-end gap-2 mt-2">
                                                                <button
                                                                    type="button"
                                                                    onClick={() => startEditActivity(act)}
                                                                    className="px-2 py-1 rounded-lg border border-[#0b4d78] hover:bg-[#10324f]"
                                                                >
                                                                    Editar
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    onClick={() => deleteActivity(act.id)}
                                                                    className="px-2 py-1 rounded-lg border border-red-200 text-red-700 hover:bg-red-50"
                                                                >
                                                                    Eliminar
                                                                </button>
                                                            </div>
                                                        ) : null}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>

                                    <div className="border-t border-[#0b4d78] px-4 py-3 text-[11px]">
                                        <div className="font-semibold text-white mb-1">
                                            {activityEditId ? "Editar actividad" : "Nueva actividad"}
                                        </div>

                                        {canEdit ? (
                                            <form onSubmit={saveActivity} className="space-y-2">
                                                <div className="grid grid-cols-2 gap-2">
                                                    <div>
                                                        <label className="block text-[#d7e8f6] mb-1">Tipo</label>
                                                        <select
                                                            value={activityForm.type}
                                                            onChange={(e) =>
                                                                setActivityForm((prev) => ({ ...prev, type: e.target.value }))
                                                            }
                                                            className="w-full border border-[#0b4d78] rounded-lg px-2 py-1 text-[11px] focus:outline-none focus:ring-1 focus:ring-cani-primary"
                                                        >
                                                            <option value="email_enviado">Email enviado</option>
                                                            <option value="email_recibido">Email recibido</option>
                                                            <option value="llamada">Llamada</option>
                                                            <option value="whatsapp">WhatsApp</option>
                                                            <option value="reunion">Reunión</option>
                                                            <option value="documento_enviado">Documento enviado</option>
                                                            <option value="documento_recibido">Documento recibido</option>
                                                            <option value="otro">Otro</option>
                                                        </select>
                                                    </div>
                                                    <div>
                                                        <label className="block text-[#d7e8f6] mb-1">Canal</label>
                                                        <select
                                                            value={activityForm.channel}
                                                            onChange={(e) =>
                                                                setActivityForm((prev) => ({ ...prev, channel: e.target.value }))
                                                            }
                                                            className="w-full border border-[#0b4d78] rounded-lg px-2 py-1 text-[11px] focus:outline-none focus:ring-1 focus:ring-cani-primary"
                                                        >
                                                            <option value="email">Email</option>
                                                            <option value="telefono">Teléfono</option>
                                                            <option value="whatsapp">WhatsApp</option>
                                                            <option value="presencial">Presencial</option>
                                                            <option value="plataforma">Plataforma</option>
                                                        </select>
                                                    </div>
                                                </div>

                                                <div>
                                                    <label className="block text-[#d7e8f6] mb-1">Asunto / resumen</label>
                                                    <input
                                                        type="text"
                                                        value={activityForm.subject}
                                                        onChange={(e) =>
                                                            setActivityForm((prev) => ({ ...prev, subject: e.target.value }))
                                                        }
                                                        className="w-full border border-[#0b4d78] rounded-lg px-2 py-1 text-[11px] focus:outline-none focus:ring-1 focus:ring-cani-primary"
                                                    />
                                                </div>

                                                <div>
                                                    <label className="block text-[#d7e8f6] mb-1">Detalle</label>
                                                    <textarea
                                                        rows={2}
                                                        value={activityForm.description}
                                                        onChange={(e) =>
                                                            setActivityForm((prev) => ({
                                                                ...prev,
                                                                description: e.target.value,
                                                            }))
                                                        }
                                                        className="w-full border border-[#0b4d78] rounded-lg px-2 py-1 text-[11px] focus:outline-none focus:ring-1 focus:ring-cani-primary resize-none"
                                                        placeholder="Qué se habló, qué se acordó, próximos pasos..."
                                                    />
                                                </div>

                                                <div className="flex justify-end gap-2">
                                                    {activityEditId ? (
                                                        <button
                                                            type="button"
                                                            onClick={resetActivityForm}
                                                            className="px-3 py-1.5 rounded-lg border border-[#0b4d78] text-[#d9e8f5] text-[11px] hover:bg-[#10324f]"
                                                        >
                                                            Cancelar
                                                        </button>
                                                    ) : null}

                                                    <button
                                                        type="submit"
                                                        disabled={savingActivity}
                                                        className="px-3 py-1.5 rounded-lg bg-[#d4af37] text-white text-[11px] hover:bg-[#d4af37]Light disabled:opacity-60"
                                                    >
                                                        {savingActivity
                                                            ? "Guardando..."
                                                            : activityEditId
                                                                ? "Actualizar actividad"
                                                                : "Agregar actividad"}
                                                    </button>
                                                </div>
                                            </form>
                                        ) : (
                                            <div className="text-[11px] text-gray-400">
                                                No tienes permiso para agregar actividades.
                                            </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <Modal
                    open={modalOpen}
                    title={draft?.id ? "Empresa objetivo · Detalle" : "Nueva empresa objetivo"}
                    subtitle={draft?.id ? `ID ${draft.id} · ${detailMode === "contacts" ? "Contactos" : detailMode === "activities" ? "Actividades" : "Detalle general"}` : "Crear registro"}
                    onClose={() => {
                        setModalOpen(false);
                        setStructureEdit(null);
                    }}
                >
                    {draft ? (
                        <>
                            {draft?.id ? (
                                <div className="flex flex-wrap gap-2 mb-3">
                                    <button
                                        type="button"
                                        onClick={() => setDetailMode("detail")}
                                        className={`px-3 py-1.5 rounded-lg border text-xs ${detailMode === "detail" ? "bg-[#d4af37] text-white border-cani-primary" : "bg-[#04192b] border-[#0b4d78] text-[#d9e8f5]"}`}
                                    >
                                        Ver detalle
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => setDetailMode("contacts")}
                                        className={`px-3 py-1.5 rounded-lg border text-xs ${detailMode === "contacts" ? "bg-[#d4af37] text-white border-cani-primary" : "bg-[#04192b] border-[#0b4d78] text-[#d9e8f5]"}`}
                                    >
                                        Contactos
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => setDetailMode("activities")}
                                        className={`px-3 py-1.5 rounded-lg border text-xs ${detailMode === "activities" ? "bg-[#d4af37] text-white border-cani-primary" : "bg-[#04192b] border-[#0b4d78] text-[#d9e8f5]"}`}
                                    >
                                        Actividades
                                    </button>
                                </div>
                            ) : null}

                            <div className={detailMode === "contacts" || detailMode === "activities" ? "hidden" : "form-grid"}>
                                <div className="form-field full-width">
                                    <label>Nombre</label>
                                    <input
                                        value={draft.name}
                                        onChange={(e) => setDraft({ ...draft, name: e.target.value })}
                                    />
                                </div>

                                <div className="form-field">
                                    <label>Etapa</label>
                                    <select
                                        value={draft.status || ""}
                                        onChange={(e) => setDraft({ ...draft, status: e.target.value })}
                                    >
                                        {STATUS_OPTIONS.map((s) => (
                                            <option key={s} value={s}>
                                                {s}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="form-field">
                                    <label>Región</label>
                                    <select
                                        value={draft.region || ""}
                                        onChange={(e) => setDraft({ ...draft, region: e.target.value })}
                                    >
                                        <option value="">— Seleccionar —</option>
                                        {regionsOptions
                                            .filter(Boolean)
                                            .map((r) => (
                                                <option key={r} value={r}>
                                                    {r}
                                                </option>
                                            ))}
                                    </select>
                                </div>

                                <div className="form-field">
                                    <label>Ciudad</label>
                                    <input
                                        value={draft.city || ""}
                                        onChange={(e) => setDraft({ ...draft, city: e.target.value })}
                                    />
                                </div>

                                <div className="form-field">
                                    <label>Rubro</label>
                                    <input
                                        value={draft.sector_text || ""}
                                        onChange={(e) => setDraft({ ...draft, sector_text: e.target.value })}
                                    />
                                </div>

                                <div className="form-field">
                                    <label>Teléfono</label>
                                    <input
                                        value={draft.phone || ""}
                                        onChange={(e) => setDraft({ ...draft, phone: e.target.value })}
                                    />
                                </div>

                                <div className="form-field">
                                    <label>Email</label>
                                    <input
                                        value={draft.email || ""}
                                        onChange={(e) => setDraft({ ...draft, email: e.target.value })}
                                    />
                                </div>

                                <div className="form-field full-width">
                                    <label>Dirección</label>
                                    <input
                                        value={draft.address || ""}
                                        onChange={(e) => setDraft({ ...draft, address: e.target.value })}
                                    />
                                </div>

                                <div className="form-field full-width">
                                    <label>Sitio web</label>
                                    <input
                                        value={draft.website || ""}
                                        onChange={(e) => setDraft({ ...draft, website: e.target.value })}
                                    />
                                </div>

                                <div className="form-field full-width">
                                    <label>Notas</label>
                                    <textarea
                                        rows={3}
                                        value={draft.notes || ""}
                                        onChange={(e) => setDraft({ ...draft, notes: e.target.value })}
                                    />
                                </div>

                                <div className="form-field full-width">
                                    <label>Eje / Industria</label>
                                    <select
                                        value={draft.industry_id || ""}
                                        onChange={async (e) => {
                                            const nextId = e.target.value;
                                            setDraft({ ...draft, industry_id: nextId, section_id: "" });
                                            await loadSections(nextId);
                                        }}
                                    >
                                        <option value="">— Seleccionar —</option>
                                        {industries.map((i) => (
                                            <option key={i.id} value={String(i.id)}>
                                                {i.code || i.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="form-field full-width">
                                    <label>Sección del eje</label>

                                    {sectionsLoading ? (
                                        <div style={{ fontSize: 12, color: "#6b7280" }}>
                                            Cargando secciones...
                                        </div>
                                    ) : null}

                                    {!draft.industry_id ? (
                                        <div style={{ fontSize: 12, color: "#6b7280" }}>
                                            Selecciona un eje para ver secciones.
                                        </div>
                                    ) : (
                                        <>
                                            <select
                                                value={draft.section_id || ""}
                                                onChange={(e) => setDraft({ ...draft, section_id: e.target.value })}
                                            >
                                                <option value="">— Seleccionar sección —</option>
                                                {sections.map((sec) => (
                                                    <option key={sec.id} value={String(sec.id)}>
                                                        {getSectionOptionLabel(sec)}
                                                    </option>
                                                ))}
                                            </select>

                                            {draft.section_id ? (
                                                <div
                                                    style={{
                                                        marginTop: 8,
                                                        padding: 10,
                                                        border: "1px solid #e5e7eb",
                                                        borderRadius: 12,
                                                        background: "#fafafa",
                                                    }}
                                                >
                                                    {sections
                                                        .filter((sec) => String(sec.id) === String(draft.section_id))
                                                        .map((sec) => (
                                                            <div key={sec.id}>
                                                                <div
                                                                    style={{
                                                                        fontSize: 13,
                                                                        fontWeight: 600,
                                                                        color: "#111827",
                                                                    }}
                                                                >
                                                                    {getSectionOptionLabel(sec)}
                                                                </div>
                                                                {sec.description ? (
                                                                    <div
                                                                        style={{
                                                                            fontSize: 11,
                                                                            color: "#6b7280",
                                                                            marginTop: 4,
                                                                            lineHeight: 1.35,
                                                                        }}
                                                                    >
                                                                        {sec.description}
                                                                    </div>
                                                                ) : null}
                                                            </div>
                                                        ))}
                                                </div>
                                            ) : null}
                                        </>
                                    )}
                                </div>

                                {canAdmin ? (
                                    <div className="form-field full-width">
                                        <label>PM responsable</label>
                                        <select
                                            value={draft.pm_user_id ?? ""}
                                            onChange={(e) => setDraft({ ...draft, pm_user_id: e.target.value })}
                                        >
                                            <option value="">—</option>
                                            {pmUsers.map((u) => (
                                                <option key={u.id} value={String(u.id)}>
                                                    {u.display_name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                ) : null}
                            </div>

                            <div className="form-actions" style={{ marginTop: 12 }}>
                                {((!draft?.id && canCreate) || (draft?.id && canEdit)) ? (
                                    <button className="btn btn-primary" onClick={saveCompany}>
                                        Guardar
                                    </button>
                                ) : null}

                                {draft?.id && canDelete ? (
                                    <button className="btn btn-danger" onClick={() => deleteCompany(draft.id)}>
                                        Eliminar empresa
                                    </button>
                                ) : null}

                                <button className="btn btn-secondary" onClick={() => setModalOpen(false)}>
                                    Cerrar
                                </button>
                            </div>

                            {draft.id && detailMode !== "activities" ? (
                                <div className="card" style={{ marginTop: 16 }}>
                                    <div className="card-header-inline">
                                        <h3 className="card-title" style={{ margin: 0 }}>
                                            Contactos vinculados
                                        </h3>
                                        <span className="badge">
                                            {companyContactsLoading ? "Cargando..." : `${companyContacts.length} contacto(s)`}
                                        </span>
                                    </div>

                                    <div className="form-grid">
                                        <div className="form-field full-width">
                                            <label>Buscar en catálogo maestro</label>
                                            <input
                                                value={contactSearch}
                                                onChange={(e) => setContactSearch(e.target.value)}
                                                placeholder="Nombre, email, puesto..."
                                            />
                                        </div>

                                        <div className="form-field full-width">
                                            <label>Seleccionar contacto</label>
                                            <select
                                                value={contactPickerId}
                                                onChange={(e) => setContactPickerId(e.target.value)}
                                                disabled={masterContactsLoading || linkingContact}
                                            >
                                                <option value="">
                                                    {masterContactsLoading
                                                        ? "Cargando catálogo..."
                                                        : "— Seleccionar contacto —"}
                                                </option>
                                                {filteredMasterContacts.map((c) => (
                                                    <option key={c.id} value={String(c.id)}>
                                                        {getContactDisplayName(c)}
                                                        {c.position ? ` · ${c.position}` : ""}
                                                        {c.email ? ` · ${c.email}` : ""}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="form-actions full-width">
                                            {canEdit ? (
                                                <button
                                                    className="btn btn-primary"
                                                    onClick={() => attachContactToCompany(draft.id, contactPickerId)}
                                                    disabled={!contactPickerId || linkingContact}
                                                >
                                                    {linkingContact ? "Guardando..." : "Vincular contacto"}
                                                </button>
                                            ) : null}
                                        </div>
                                    </div>

                                    <div className="table-wrapper" style={{ width: "100%", overflowX: "auto" }}>
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>Contacto</th>
                                                    <th>Puesto</th>
                                                    <th>Email</th>
                                                    <th>Teléfono</th>
                                                    <th style={{ width: 180 }}>Acciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {companyContacts.map((it) => (
                                                    <tr key={it.id || `${it.company_id}-${it.contact_id}`}>
                                                        <td>
                                                            <strong>{getContactDisplayName(it)}</strong>
                                                        </td>
                                                        <td>{it.position || "—"}</td>
                                                        <td style={{ fontSize: 12, color: "#666" }}>{it.email || "—"}</td>
                                                        <td style={{ fontSize: 12, color: "#666" }}>
                                                            {it.mobile || it.phone || "—"}
                                                        </td>
                                                        <td>
                                                            <div className="form-actions">
                                                                {canEdit ? (
                                                                    <button
                                                                        className="btn btn-danger btn-small"
                                                                        onClick={() => detachContactFromCompany(it.id, draft.id)}
                                                                    >
                                                                        Quitar
                                                                    </button>
                                                                ) : null}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}

                                                {!companyContactsLoading && companyContacts.length === 0 ? (
                                                    <tr>
                                                        <td colSpan={5} style={{ color: "#6b7280" }}>
                                                            Sin contactos vinculados
                                                        </td>
                                                    </tr>
                                                ) : null}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ) : null}


                            {draft.id && detailMode !== "contacts" ? (
                                <div className="card" style={{ marginTop: 16 }}>
                                    <div className="card-header-inline">
                                        <h3 className="card-title" style={{ margin: 0 }}>
                                            Actividades de afiliación
                                        </h3>
                                        <span className="badge">
                                            {activitiesLoading ? "Cargando..." : `${activities.length} actividad(es)`}
                                        </span>
                                    </div>

                                    <form onSubmit={saveActivity} className="form-grid">
                                        <div className="form-field">
                                            <label>Tipo</label>
                                            <select
                                                value={activityForm.type}
                                                onChange={(e) => setActivityForm({ ...activityForm, type: e.target.value })}
                                            >
                                                <option value="email_enviado">Email enviado</option>
                                                <option value="llamada">Llamada</option>
                                                <option value="whatsapp">WhatsApp</option>
                                                <option value="reunion">Reunión</option>
                                                <option value="documentos">Documentos</option>
                                                <option value="seguimiento">Seguimiento</option>
                                            </select>
                                        </div>

                                        <div className="form-field">
                                            <label>Canal</label>
                                            <select
                                                value={activityForm.channel}
                                                onChange={(e) => setActivityForm({ ...activityForm, channel: e.target.value })}
                                            >
                                                <option value="email">Email</option>
                                                <option value="telefono">Teléfono</option>
                                                <option value="whatsapp">WhatsApp</option>
                                                <option value="presencial">Presencial</option>
                                                <option value="videollamada">Videollamada</option>
                                            </select>
                                        </div>

                                        <div className="form-field full-width">
                                            <label>Asunto</label>
                                            <input
                                                value={activityForm.subject}
                                                onChange={(e) => setActivityForm({ ...activityForm, subject: e.target.value })}
                                                placeholder="Ej. Seguimiento para documentación institucional"
                                            />
                                        </div>

                                        <div className="form-field full-width">
                                            <label>Descripción / resultado</label>
                                            <textarea
                                                rows={3}
                                                value={activityForm.description}
                                                onChange={(e) => setActivityForm({ ...activityForm, description: e.target.value })}
                                                placeholder="Describe qué se hizo, respuesta del prospecto y siguiente paso sugerido."
                                            />
                                        </div>

                                        <div className="form-actions full-width">
                                            {canEdit ? (
                                                <button className="btn btn-primary" type="submit" disabled={savingActivity}>
                                                    {savingActivity ? "Guardando..." : activityEditId ? "Actualizar actividad" : "Guardar actividad"}
                                                </button>
                                            ) : null}

                                            {activityEditId ? (
                                                <button className="btn btn-secondary" type="button" onClick={resetActivityForm}>
                                                    Cancelar edición
                                                </button>
                                            ) : null}
                                        </div>
                                    </form>

                                    <div className="table-wrapper" style={{ width: "100%", overflowX: "auto", marginTop: 12 }}>
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>Fecha</th>
                                                    <th>Tipo / canal</th>
                                                    <th>Asunto</th>
                                                    <th>Descripción</th>
                                                    <th>Usuario</th>
                                                    <th style={{ width: 180 }}>Acciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {activities.map((act) => (
                                                    <tr key={act.id}>
                                                        <td style={{ fontSize: 12 }}>{act.created_at || "—"}</td>
                                                        <td>
                                                            <strong>{act.type || "—"}</strong>
                                                            <div style={{ fontSize: 11, color: "#6b7280" }}>{act.channel || "—"}</div>
                                                        </td>
                                                        <td>{act.subject || "—"}</td>
                                                        <td style={{ fontSize: 12, color: "#6b7280" }}>{act.description || "—"}</td>
                                                        <td style={{ fontSize: 12 }}>{act.user_name || "—"}</td>
                                                        <td>
                                                            <div className="form-actions">
                                                                {canEdit ? (
                                                                    <button className="btn btn-secondary btn-small" type="button" onClick={() => startEditActivity(act)}>
                                                                        Editar
                                                                    </button>
                                                                ) : null}
                                                                {canEdit ? (
                                                                    <button className="btn btn-danger btn-small" type="button" onClick={() => deleteActivity(act.id)}>
                                                                        Eliminar
                                                                    </button>
                                                                ) : null}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}

                                                {!activitiesLoading && activities.length === 0 ? (
                                                    <tr>
                                                        <td colSpan={6} style={{ color: "#6b7280" }}>
                                                            Sin actividades registradas para esta empresa.
                                                        </td>
                                                    </tr>
                                                ) : null}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ) : null}

                            {draft.id && ACTIVE_STATUSES.has(draft.status) && detailMode === "detail" ? (
                                <div className="card" style={{ marginTop: 16 }}>
                                    <div className="card-header-inline">
                                        <h3 className="card-title" style={{ margin: 0 }}>
                                            Estructura del afiliado
                                        </h3>
                                        <span className="badge">
                                            {structureLoading ? "Cargando..." : `${structureItems.length} item(s)`}
                                        </span>
                                    </div>

                                    <div className="form-grid">
                                        <div className="form-field">
                                            <label>Rol</label>
                                            <input
                                                value={structureEdit?.role_title ?? structureDraft.role_title}
                                                onChange={(e) => {
                                                    const v = e.target.value;
                                                    structureEdit
                                                        ? setStructureEdit({ ...structureEdit, role_title: v })
                                                        : setStructureDraft({ ...structureDraft, role_title: v });
                                                }}
                                            />
                                        </div>

                                        <div className="form-field">
                                            <label>Nombre</label>
                                            <input
                                                value={structureEdit?.person_name ?? structureDraft.person_name}
                                                onChange={(e) => {
                                                    const v = e.target.value;
                                                    structureEdit
                                                        ? setStructureEdit({ ...structureEdit, person_name: v })
                                                        : setStructureDraft({ ...structureDraft, person_name: v });
                                                }}
                                            />
                                        </div>

                                        <div className="form-field">
                                            <label>Email</label>
                                            <input
                                                value={structureEdit?.email ?? structureDraft.email}
                                                onChange={(e) => {
                                                    const v = e.target.value;
                                                    structureEdit
                                                        ? setStructureEdit({ ...structureEdit, email: v })
                                                        : setStructureDraft({ ...structureDraft, email: v });
                                                }}
                                            />
                                        </div>

                                        <div className="form-field">
                                            <label>Teléfono</label>
                                            <input
                                                value={structureEdit?.phone ?? structureDraft.phone}
                                                onChange={(e) => {
                                                    const v = e.target.value;
                                                    structureEdit
                                                        ? setStructureEdit({ ...structureEdit, phone: v })
                                                        : setStructureDraft({ ...structureDraft, phone: v });
                                                }}
                                            />
                                        </div>

                                        <div className="form-field full-width">
                                            <label>Notas</label>
                                            <textarea
                                                rows={2}
                                                value={structureEdit?.notes ?? structureDraft.notes}
                                                onChange={(e) => {
                                                    const v = e.target.value;
                                                    structureEdit
                                                        ? setStructureEdit({ ...structureEdit, notes: v })
                                                        : setStructureDraft({ ...structureDraft, notes: v });
                                                }}
                                            />
                                        </div>

                                        <div className="form-actions full-width">
                                            {canEdit ? (
                                                <button className="btn btn-primary" onClick={saveStructure}>
                                                    {structureEdit ? "Actualizar" : "Agregar"}
                                                </button>
                                            ) : null}

                                            {structureEdit ? (
                                                <button
                                                    className="btn btn-secondary"
                                                    onClick={() => setStructureEdit(null)}
                                                >
                                                    Cancelar
                                                </button>
                                            ) : null}
                                        </div>
                                    </div>

                                    <div className="table-wrapper" style={{ width: "100%", overflowX: "auto" }}>
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>Rol</th>
                                                    <th>Nombre</th>
                                                    <th>Email</th>
                                                    <th>Teléfono</th>
                                                    <th style={{ width: 220 }}>Acciones</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {structureItems.map((it) => (
                                                    <tr key={it.id}>
                                                        <td>
                                                            <strong>{it.role_title}</strong>
                                                        </td>
                                                        <td>{it.person_name || "—"}</td>
                                                        <td style={{ fontSize: 12, color: "#666" }}>{it.email || "—"}</td>
                                                        <td style={{ fontSize: 12, color: "#666" }}>{it.phone || "—"}</td>
                                                        <td>
                                                            <div className="form-actions">
                                                                {canEdit ? (
                                                                    <button
                                                                        className="btn btn-secondary btn-small"
                                                                        onClick={() => setStructureEdit({ ...it })}
                                                                    >
                                                                        Editar
                                                                    </button>
                                                                ) : null}

                                                                {canEdit ? (
                                                                    <button
                                                                        className="btn btn-danger btn-small"
                                                                        onClick={() => deleteStructure(it.id)}
                                                                    >
                                                                        Eliminar
                                                                    </button>
                                                                ) : null}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}

                                                {structureItems.length === 0 ? (
                                                    <tr>
                                                        <td colSpan={5} style={{ color: "#6b7280" }}>
                                                            Sin estructura registrada
                                                        </td>
                                                    </tr>
                                                ) : null}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ) : null}
                        </>
                    ) : null}
                </Modal>

                <Modal
                    open={importOpen}
                    title="Importar empresas objetivo"
                    subtitle="Sube un archivo Excel. Cada hoja se tomará como una región."
                    onClose={() => {
                        if (importing) return;
                        setImportOpen(false);
                        setImportFile(null);
                    }}
                >
                    <form onSubmit={handleImportSubmit} className="space-y-4">
                        <div className="text-xs text-[#d7e8f6] space-y-1">
                            <p>Formato esperado por hoja:</p>
                            <p><strong>A:</strong> Nombre</p>
                            <p><strong>B:</strong> Rubro / sector</p>
                            <p><strong>C:</strong> Dirección</p>
                            <p><strong>D:</strong> Ciudad</p>
                            <p><strong>E:</strong> Teléfono</p>
                            <p><strong>F:</strong> Email</p>
                            <p><strong>G:</strong> Sitio web</p>
                            <p><strong>H:</strong> Notas</p>
                        </div>

                        <div>
                            <label className="block text-[11px] text-[#d7e8f6] mb-1">Archivo Excel</label>
                            <input
                                type="file"
                                accept=".xlsx,.xls"
                                onChange={(e) => setImportFile(e.target.files?.[0] || null)}
                                className="w-full border border-[#0b4d78] rounded-lg px-3 py-2 text-xs"
                            />
                        </div>

                        <div className="text-[11px] text-[#9fc4df]">
                            La región se tomará del nombre de cada hoja. Los registros repetidos por nombre + región se omitirán.
                        </div>

                        <div className="flex justify-end gap-2">
                            <button
                                type="button"
                                onClick={() => {
                                    if (importing) return;
                                    setImportOpen(false);
                                    setImportFile(null);
                                }}
                                className="px-3 py-1.5 rounded-lg border border-[#0b4d78] text-[#d9e8f5] text-xs hover:bg-[#10324f]"
                            >
                                Cancelar
                            </button>

                            <button
                                type="submit"
                                disabled={!importFile || importing}
                                className="px-3 py-1.5 rounded-lg bg-[#d4af37] text-white text-xs hover:bg-[#d4af37]Light disabled:opacity-60"
                            >
                                {importing ? "Importando..." : "Importar archivo"}
                            </button>
                        </div>
                    </form>
                </Modal>

                {toast ? (
                    <div
                        className="card"
                        style={{
                            position: "fixed",
                            right: 16,
                            bottom: 16,
                            zIndex: 3000,
                            maxWidth: 560,
                        }}
                    >
                        <div style={{ fontWeight: 700, marginBottom: 6 }}>
                            {toast.type === "error" ? "Error" : "OK"}
                        </div>
                        <div style={{ color: "#111827" }}>{toast.msg}</div>
                    </div>
                ) : null}
            </div>
        </MainLayout>
    );
}
